import { Component, OnInit, Input, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { ApiCallsService } from "@app/routes/dashboard/pages/dashboard/api-call-service";
import { UtilsService } from "@app/core/utils.service";
@Component({
  selector: "app-history-dialogcharts",
  templateUrl: "./history-dialogcharts.component.html",
  styleUrls: ["./history-dialogcharts.component.css"],
})
export class HistoryDialogchartsComponent implements OnInit {
  // [x: string]: any;
  token = localStorage.getItem("user");
  selectedMIX: any = [];
  selectedMIXID = "DASB198960";
  selectedMixID: any = [];
  selectedJobno: any = [];
  selectedJOBNO: any = [];
  selectedPlanttype: any = [];
  selectPlantType: any = [];
  appliedDateFilters: any = {};
  MIXData: any = [];
  selectedPlant = "TCII";
  selectedJOB = "09-023";
  UnionAlertsData: any = [];
  selectonemixid: any[];
  ListMixID: any = [];
  selectlistmixid: any;
  perfEffncyData: any;
  qeDeviationIndexData: any;
  EnergyDeviationIndexData: any[];
  carbonindexdata: any;
  OEEData: any;
  EneData: any;
  TPData: any[];
  StatusType: any;
  keys: string[];
  keyValuePairs: { key: string; values: any }[] = [];
  MixIdNames: any[];
  Mixlistdata: any;
  mixIdData: any;
  Mixlisttopdata: any;
  SumData: any;
  RoleId: any;
  OperatorRole: any;
  usernamedisplay: any;
  selectDPlantType: any;
  isDefinedFilterSelected: boolean = false;
  selectedDefaultDate: string;
  clicked: any;
  gaspertondata: any;
  GCperdata: any;
  GCfdata1: any[];
  GCIdperNames: any[];
  GCtonName: any[];
  ProdEC: any;
  GCData: any[];
  GCfdata: any[];
  GCIdNames: any[];
  ProdHours: any;
  ProdTP: any;
  Valueschanged: any;
  ProdLoss: any;
  ProdOEE: any;
  IsDropdownTrue: boolean = true;
  ProdUnifiedData: any;
  ProductionHrs: any;
  ProdEff: any;
  QualEff: any;
  EnergyEff: any;
  CarbonEff: any;
  TPdata: any;
  TPIdNames: any;
  TPName: any;
  mergedData: any;
  GADIdnames: any;
  DrumName: any;
  AmbName: any;
  EnergyUnifiedData: any;
  ThroughputGas: any;
  GasDrumData: any;
  GasAmbData: any;
  GADdata: any[];
  moistureTrend: any;
  gasUsage: any;
  dateRangaPicker: any;
  KPI4: any;
  productionData: any;
  KPIqualitySaving: any;
  wastage: any;
  mixWasteData: any;
  constructor(
    public dialogRef: MatDialogRef<HistoryDialogchartsComponent>,
    readonly apiCallsService: ApiCallsService,
    readonly utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    
    this.selectonemixid = this.data.SelectedMixId;
    
  
    if (this.utils.dateFilter) {
      this.isDefinedFilterSelected = false;
      this.appliedDateFilters["start_date"] = new Date(this.utils.dateFilter["start_date"]);
      this.appliedDateFilters["end_date"] = new Date(this.utils.dateFilter["end_date"]);
    } else {
      this.selectedDefaultDate = "Yesterday";
      const currentDate = new Date();
      const oneDayInMillis = 24 * 60 * 60 * 1000;
      this.appliedDateFilters["start_date"] = new Date(currentDate.getTime() - 7 * oneDayInMillis);
      this.appliedDateFilters["end_date"] = new Date(currentDate.getTime() - oneDayInMillis);
    }
  
    switch (this.data.clicked) {
      case 1:
        this.ProdEff = this.data.graphData;
        this.drawProductionChart();
        break;
      case 3:
        this.QualEff = this.data.graphData;
        this.drawQualityeffncyChart();
        break;
      case 4:
        this.EnergyEff = this.data.graphData;
        this.drawEnergyeffncyChart();
        break;
      case 5:
        this.CarbonEff = this.data.graphData;
        this.drawCarbonIndexchart();
        break;
      case 6:
        this.getunionAlert();
        break;
      case 7:
        this.ProdOEE = this.data.graphData;
        this.drawProdOEEchart();
        break;
      case 8:
        this.ProdTP = this.data.graphData;
        this.drawProdTPchart();
        break;
      case 9:
        this.GCfdata = this.data.graphData;
        this.GCIdNames = this.data.graphGCNames;
        this.GCtonName = this.data.graphgcperton;
        this.DrawChartGC();
        break;
      case 10:
        this.ProdLoss = this.data.graphData;
        this.drawProdlosschart();
        break;
      case 11:
        this.DrawPvsNP();
        break;
      case 12:
      case 13:
        this.ProdHours = this.data.graphData;
        setTimeout(() => {
          this.data.clicked == 12 ? this.DrawProdGasQnty() : this.DrawNonProdGasQnty();
        }, 100);
        console.log(" this.data.clicked",  this.data.clicked)
        break;
      case 14:
        this.mixIdData = this.data.graphData;
        this.MixIdNames = this.data.graphMixIdNames;
        this.DrawMixID();
        this.keysnValues();
        break;
      case 15:
        this.GCfdata = this.data.graphData;
        this.DrawChartGCNP();
        break;
        case 16:
          this.TPdata = this.data.graphData;
          this.TPIdNames = this.data.graphTPnames;
          this.TPName = this.data.graphTPnamedata;

          this.DrawChartTP();
          console.log(" this.TPdata", this.TPName,  this.TPIdNames,this.TPdata, this.data.clicked)
          break;
          case 17:
            this.mergedData = this.data.graphData;
            this.GADIdnames = this.data.graphGASidname;
            this.DrumName = this.data.graphDrumname;
            this.AmbName = this.data.graphAmbname;
            console.log(" this.mergedData",this.mergedData, this.data.clicked)
            this.DrawChartGAD();
            break;
            case 18:
              this.mergedData = this.data.graphData;
              this.GADIdnames = this.data.graphGASidname;
              this.DrumName = this.data.graphDrumname;
              this.AmbName = this.data.graphAmbname;
              console.log(" this.mergedData",this.mergedData, this.data.clicked)
              this.DrawChartNPGAD();
              break;
            case 19:
              console.log(this.data.graphData,"in hist")
              console.log("data clicked",this.data.clicked)
              this.moistureTrend = this.data.graphData
              this.dateRangaPicker = this.data.date
              this.drawLineChart1();
              break;
            case 20:
              this.gasUsage = this.data.graphData
              this.gasUsage = this.data.graphData2
              this.dateRangaPicker = this.data.date
              this.drawLineChart3();
              break;
            case 21:
              this.productionData = this.data.graphData
              this.KPI4 = this.data.graphData3
              console.log(this.productionData,"productionData")
              console.log(this.KPI4,"kpi4")
              this.drawProductionImprovementChart();
              break;
            case 22:
              this.KPIqualitySaving = this.data.graphData
              this.dateRangaPicker = this.data.date

              this.drawLineChart2()
              break;
            case 23:
              this.wastage = this.data.graphData

              console.log(this.wastage,"wastage")
              this.drawwastageChart()
              break;
              case 24:
                this.mixWasteData = this.data.graphData
                this.drawWastechart();
                break;


      default:
        break;
    }
  }
  

  closed() {
    this.dialogRef.close();
  }
  showNoDataMessage(chart) {
    const noDataAvailable = 
      !chart.data || 
      chart.data.length === 0 || 
      !this.KPI4 || 
      this.KPI4.length === 0 || 
      !this.KPI4.some(item => item.mix_id != null);
    if (noDataAvailable) {
      const label = chart.chartContainer.createChild(am4core.Label);
      label.text = "Production data not available for this date";
      label.dy = -120;
      label.fontSize = 15;
      label.align = "center";
      label.fill = am4core.color("#d1d1d1");
      return true; // Return true to indicate "no data"
    }
  
    return false; // Data exists
  }
  drawwastageChart() {
  setTimeout(() => {
        am4core.useTheme(am4themes_animated);
    
        // Create chart instance
        var chart = am4core.create('mixWastage', am4charts.XYChart);
        chart.logo.disabled = true;
        chart.paddingRight = 15;
        chart.data = this.wastage;;  // Assuming this.KPI1 is your dataset
        console.log("chart data",chart.data)
        // if (this.showNoDataMessage(chart)) {
        //   return; // Exit if there's no data
        // }
        // Set input format for the dates
        chart.dateFormatter.inputDateFormat = 'dd-MM-yyyy';  // Your date format
    
        // Create date axis
        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.renderer.minGridDistance = 40;
        dateAxis.title.fill = am4core.color('#fff');
        dateAxis.title.text = "Date";
        dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
        dateAxis.renderer.labels.template.fill = am4core.color('#fff');
        dateAxis.renderer.labels.template.fontSize = 12;
    
        // Set base interval for dates
        dateAxis.baseInterval = { timeUnit: 'day', count: 1 };
        // dateAxis.min = new Date(this.dateRangaPicker[0]).setHours(0, 0, 0, 0);
        // dateAxis.max = new Date(this.dateRangaPicker[1]).setHours(23, 59, 59, 999);
        dateAxis.skipEmptyPeriods = false;
        dateAxis.title.fontSize = 12;
        dateAxis.dateFormats.setKey("day", "d MMM");
        dateAxis.periodChangeDateFormats.setKey("day", "d MMM");
        dateAxis.tooltipDateFormat = 'd MMM';
        dateAxis.renderer.cellStartLocation = 0.1;
        dateAxis.renderer.cellEndLocation = 0.9;
        
        // Add cursor
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = dateAxis;
        chart.cursor.lineY.disabled = false;
    
        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.renderer.inside = false;
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.title.text = 'Total Mix Wastage (Tons)';
        valueAxis.title.fill = am4core.color('#fff');
        valueAxis.title.fontSize = 12;
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.renderer.labels.template.fill = am4core.color('#fff');
        valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
        valueAxis.cursorTooltipEnabled = false;
        
        // Add legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";
        chart.legend.contentAlign = "center";
        chart.legend.fontSize = 12;
        chart.legend.markers.template.width = 14;
        chart.legend.markers.template.height = 14;
        chart.legend.labels.template.fill = am4core.color('#fff');
        chart.legend.valueLabels.template.fill = am4core.color('#fff');
        // this.adjustLegendItems(chart);
        // window.addEventListener("resize", () => this.adjustLegendItems(chart));
        
        var data = this.wastage;
        // Group data by `mixID` and create a series for each `mixID`
        let mixIDs = [...new Set(data.map(item => item.mix_id))];  // Get unique mixIDs
        let colorCode = [
          "#a8d279",
          "#8bc550",
          "#6bbe45",
          "#40ac48",
          "#2c8943",
          "#1e6431"
        ]  // Array of colors for each series
    
        mixIDs.forEach((mixID, index) => {
            let filteredData = data.filter(item => item.mix_id === mixID);
    
            // Create column series for temperature
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = 'wastage';  // Y value for maximum temperature
            series.dataFields.dateX = 'record_time_epoch';  // Field for date/time
            series.name = `${mixID}`;  // Simplified name for legend display
            series.stroke = am4core.color(colorCode[index % colorCode.length]);  // Cycle through colors
            series.fill = am4core.color(colorCode[index % colorCode.length]);
            // series.tooltip.label.fontSize = 10;
            // series.tooltipText = `${mixID} \n Mix Wastage: {valueY} (Tons)`;
            series.columns.template.tooltipPosition = "pointer";
            series.columns.template.tooltipY = 50;
    
            // Set column width
            series.columns.template.width = am4core.percent(80);  // Adjust column width
            
            // Assign filtered data to series
            series.data = filteredData;
        });
    
        // Add chart cursor
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = dateAxis;
    
      }, 100);
  }
  drawLineChart2() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
  
      // Create chart instance
      var chart = am4core.create('qualityAnalysis', am4charts.XYChart);
      chart.logo.disabled = true;
     
      chart.paddingRight = 15;
     
      chart.data = this.KPIqualitySaving;  // Assuming this.KPI1 is your dataset
  
      // Set input format for the dates
      chart.dateFormatter.inputDateFormat = 'dd-MM-yyyy';  // Your date format
     
  
      // Create date axis
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 40;
      dateAxis.title.fill = am4core.color('#fff');
      // dateAxis.title.fontWeight = 'bold';
      dateAxis.title.text = "Date";
      dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
      dateAxis.renderer.labels.template.fill = am4core.color('#fff');
      dateAxis.renderer.labels.template.fontSize = 12;
  
      // Set base interval for dates
      dateAxis.baseInterval = { timeUnit: 'day', count: 1 };
      dateAxis.min = new Date(this.dateRangaPicker[0]).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.dateRangaPicker[1]).setHours(23, 59, 59, 999);
      dateAxis.skipEmptyPeriods = false;
      dateAxis.dateFormats.setKey("day", "d MMM");
      dateAxis.periodChangeDateFormats.setKey("day", "d MMM");
      dateAxis.tooltipDateFormat = 'd MMM';
      dateAxis.renderer.cellStartLocation = 0.1;
        dateAxis.renderer.cellEndLocation = 0.9;
        dateAxis.title.fontSize = 12;
      // Add cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      chart.cursor.lineY.disabled = false;
  
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.renderer.inside = false;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.title.text = 'Quality (%)';
      valueAxis.title.fill = am4core.color('#fff');
      // valueAxis.title.fontWeight = 'bold';
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color('#fff');
      valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
      valueAxis.cursorTooltipEnabled = false;
      var data = this.KPIqualitySaving;
      // Group data by `mixID` and create a series for each `mixID`
      let mixIDs = [...new Set(data.map(item => item.mix_id))];  // Get unique mixIDs
      let colorCode = [
        "#a8d279",
        "#8bc550",
        "#6bbe45",
        "#40ac48",
        "#2c8943",
        "#1e6431"
      ]  // Array of colors for each series
  
      mixIDs.forEach((mixID, index) => {
          let filteredData = data.filter(item => item.mix_id === mixID);
  
          // Create column series for temperature
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY = 'quality_savings';  // Y value for maximum temperature
          series.dataFields.dateX = 'record_time_epoch';  // Field for date/time
          series.name = `Temperature - ${mixID}`;  // Label series by mixID
          series.stroke = am4core.color(colorCode[index % colorCode.length]);  // Cycle through colors
          series.fill = am4core.color(colorCode[index % colorCode.length]);
          series.tooltip.label.fontSize = 10;
          series.tooltipText = `${mixID} \n Quality Saving: {valueY} (%)`;
          series.columns.template.tooltipPosition = "pointer";
          series.columns.template.tooltipY =50;

          // Set column width and centering
          series.columns.template.width = am4core.percent(80);  // Adjust column width
          
  
          // Assign filtered data to series
          series.data = filteredData;
      });
  
      // Add chart cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
  
  }, 100);
  }
  drawLineChart3() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
  
      // Create chart instance
      var chart = am4core.create('gasUsage', am4charts.XYChart);
      chart.logo.disabled = true;
     
      chart.paddingRight = 15;
      chart.data = this.gasUsage;  // Assuming this.KPI1 is your dataset
  
      // Set input format for the dates
      chart.dateFormatter.inputDateFormat = 'dd-MM-yyyy';  // Your date format
     
      // Create date axis
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 40;
      dateAxis.title.fill = am4core.color('#fff');
      // dateAxis.title.fontWeight = 'bold';
      dateAxis.title.text = "Date";
      dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
      dateAxis.renderer.labels.template.fill = am4core.color('#fff');
      dateAxis.renderer.labels.template.fontSize = 12;
  
      // Set base interval for dates
      dateAxis.baseInterval = { timeUnit: 'day', count: 1 };
      dateAxis.skipEmptyPeriods = false;
      dateAxis.dateFormats.setKey("day", "d MMM");
      dateAxis.min = new Date(this.dateRangaPicker[0]).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.dateRangaPicker[1]).setHours(23, 59, 59, 999);
      dateAxis.periodChangeDateFormats.setKey("day", "d MMM");
      dateAxis.tooltipDateFormat = 'd MMM';
      dateAxis.renderer.cellStartLocation = 0.1;
        dateAxis.renderer.cellEndLocation = 0.9;
        dateAxis.title.fontSize = 12;
      // Add cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      chart.cursor.lineY.disabled = false;
  
      // Create value axis for Y (Gas Flow Rate)
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.renderer.inside = false;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.title.text = 'Gas Volume (%)';
      valueAxis.title.fontSize = 12;
      valueAxis.title.fill = am4core.color('#fff');
      // valueAxis.title.fontWeight = 'bold';
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color('#fff');
      valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
      valueAxis.cursorTooltipEnabled = false;

      var data = this.gasUsage;

      let mixIDs = [...new Set(data.map(item => item.mix_id))]; 
      let colorCode = [
        "#a8d279",
        "#8bc550",
        "#6bbe45",
        "#40ac48",
        "#2c8943",
        "#1e6431"
      ] 
  
      mixIDs.forEach((mixID, index) => {
          let filteredData = data.filter(item => item.mix_id === mixID);
          
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.dataFields.valueY = 'gas_usage';  // Field for gas flow rate
          series.dataFields.dateX = 'record_time_epoch';  // Field for date/time
          series.name = `Gas Flow Rate - ${mixID}`;  // Label series by mixID
          series.stroke = am4core.color(colorCode[index % colorCode.length]);  // Cycle through colors
          series.fill = am4core.color(colorCode[index % colorCode.length]);
          series.legendSettings.labelText = "{name}";
          series.tooltipText = `${mixID}\n Gas Usage: {valueY} (%)`;
          series.tooltip.label.fontSize = 10;
          series.columns.template.width = am4core.percent(80);  // Adjust column width 
          // Assign filtered data to series
          series.columns.template.tooltipX = am4core.percent(0);
          series.columns.template.tooltipY = am4core.percent(50);

          series.data = filteredData;
      });
     
  
  }, 100);
  
  
  
  }
  drawProductionImprovementChart() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("chartImprovementProduction", am4charts.XYChart);
      
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      
       
      var chartData = this.productionData;
      chart.height = 400;

      chart.data = chartData;
  
      

      let colorCode = ["#15B392", "#54C392", "#73EC8B", "#D2FF72"];
  
      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "date"; // Set the x-axis data field as 'date'
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.labels.template.fontSize = 12;
      // categoryAxis.title.fontWeight = 'bold'; 
      categoryAxis.title.text = "Date";
      categoryAxis.title.fontSize = 12;
      categoryAxis.title.fill = am4core.color("#FFF");
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
      
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;
  
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.renderer.labels.template.fontSize = 12;
      
      valueAxis.marginRight = 45;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.min = 0;
      // valueAxis.title.fontWeight = 'bold';    
      valueAxis.title.text = "Total Mix Tons";
      valueAxis.title.fontSize = 12;
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.renderer.minGridDistance =15;
      interface DataItem {
        date: string; // or Date if you are using Date objects
        [key: string]: any; // Allows for additional dynamic fields
    }
      // Create series
      function createSeries(field: string, name: string, stacked: boolean, color: boolean, index: number) {
        const series = chart.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "date";
        series.sequencedInterpolation = true;
        series.stacked = stacked;
        series.strokeWidth = 3;
    
        const colorCode = color 
            ? ["#a8d279", "#8bc550", "#6bbe45", "#40ac48", "#2c8943", "#1e6431", "#356035"]
            : ["#e5ae76", "#ffad59", "#ff982f", "#e67d12","#f9722d" , "#ba5b01","#b05600"];
    
        const selectedColor = am4core.color(colorCode[index % colorCode.length]);
        series.stroke = selectedColor;
        series.fill = selectedColor;
        series.columns.template.width = am4core.percent(70);
        // series.tooltipText = "[font-size: 12px]{name} : {valueY.formatNumber('#.0')} Tons";
        series.tooltipText = "";
        series.tooltip.label.fontSize = 10;
        series.tooltip.dx =-20;
        series.columns.template.tooltipX = am4core.percent(100);
series.columns.template.tooltipY = am4core.percent(100);
        series.adapter.add("tooltipText", function(text) {
          var text = "[bold]{dateX}[/]\n"
          chart.series.each(function(item) {
            // var Prod =" Production"
            var actual ="Actual"
            var pred="Predicted"
            if (item.stroke instanceof am4core.Color && item.name.slice(0,10)===name.slice(0,10) && item.name.length===10) {
              text+= item.name.slice(0,10) + "\n"
              text += actual + ": {" + item.dataFields.valueY + "} (Tons)";
            } else if(item.stroke instanceof am4core.Color && item.name.slice(0,10)===name.slice(0,10) && item.name.length===15){
              text +="  ";
              text +=pred  + ": {" + item.dataFields.valueY + "} (Tons)";
            }
          });
          return name.length===15?text:null;
          
        });
        return series;
    }
    
    function getPredValueForDate(date: string, fieldName: string) {
        const entry = this.Data.find((item: DataItem) => item.date === date);
        if (entry) {
            const predField = `${fieldName}_pred`;
            return entry[predField] !== undefined ? entry[predField] : 'Prediction not available';
        }
        return 'Date not found';
    }
    
  
      // Create title and reset label (if needed)
      var title = chart.titles.create();
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = -30;
      resetLabel.y = -30;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();
  
      resetLabel.events.on("hit", function (ev) {
        resetLabel.hide();
        title.hide();
        chart.data = chartData; // Reset data if needed
      });
  
      // Get unique series names (MixIDs or similar)
      let mixIDs = Array.from(new Set(this.KPI4.map(item => String(item.mix_id)))) as string[];
      let mixIDs2 = Array.from(new Set(this.KPI4.map(item => String(item.mix_id + '_pred')))) as string[];
      console.log(mixIDs,mixIDs2,"mix id")
      // Loop through and create series for each MixID
      for (let i = 0; i < mixIDs.length; i++) {
        let MixIdName = mixIDs[i];
        createSeries(MixIdName, MixIdName,true, false,i);  
      }

      createSeries('DA1B11996','DA1B11996',false, false,0);
      
      for (let i = 0; i < mixIDs2.length; i++) {
        let MixIdName = mixIDs2[i];
        createSeries(MixIdName, MixIdName,true,true,i);
      }
    }, 150);
   
  }
 drawLineChart1() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
      
      // Create chart instance
      var chart = am4core.create("moistureTrend", am4charts.XYChart);
      chart.logo.disabled = true;
      // chart.responsive.enabled = true;
      chart.paddingRight = 15;

      chart.height = 400;
  
      // Set input format for the dates
      chart.dateFormatter.inputDateFormat = "dd-MM-yyyy";
      
  
      // Create date axis
      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 40;
      dateAxis.title.fill = am4core.color('#fff');
      // dateAxis.title.fontWeight = 'bold';
      dateAxis.title.text = "Date";
      dateAxis.title.fontSize = 12;
      dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
      dateAxis.renderer.labels.template.fill = am4core.color('#fff');
      dateAxis.renderer.labels.template.fontSize = 12;
      dateAxis.baseInterval = { timeUnit: 'day', count: 1 };
      dateAxis.dateFormats.setKey("day", "d MMM");
      dateAxis.periodChangeDateFormats.setKey("day", "d MMM");
      dateAxis.tooltipDateFormat = 'd MMM';
      dateAxis.min = new Date(this.dateRangaPicker[0]).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.dateRangaPicker[1]).setHours(23, 59, 59, 999);
      
      dateAxis.renderer.cellStartLocation = 0.1;
        dateAxis.renderer.cellEndLocation = 0.9;
      // Create value axis
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.renderer.inside = false;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.title.text = 'Moisture (%)';
      valueAxis.title.fontSize = 12;
      valueAxis.title.fill = am4core.color('#fff');
      // valueAxis.title.fontWeight = 'bold';
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color('#fff');
      valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
      valueAxis.cursorTooltipEnabled = false;
      // Assume `this.KPI1` is the array containing your data
      var data = this.moistureTrend;
  
      // Group data by `mixID` and create a series for each `mixID`
      let mixIDs = [...new Set(data.map(item => item.mix_id))];  // Get unique mixIDs
 
      
      let colorCode = [
        "#a8d279",
        "#8bc550",
        "#6bbe45",
        "#40ac48",
        "#2c8943",
        "#1e6431"
      ]      
      
      mixIDs.forEach((mixID, index) => {
          let filteredData = data.filter(item => item.mix_id === mixID);
  
          var series = chart.series.push(new am4charts.CandlestickSeries());
          series.dataFields.dateX = "record_time_epoch";
          series.dataFields.valueY = "moisture_per_min"; // Close value
          series.dataFields.openValueY = "moisture_per_max"; // Open value
          series.riseFromOpenState = undefined;
         series.dropFromOpenState = undefined;
          // let colorCode = [ "#DBB5B5", "#C39898", "#987070"];
          series.stroke = am4core.color(colorCode[index % colorCode.length]);  // Cycle through colors
          series.fill = am4core.color(colorCode[index % colorCode.length]);
          
          series.columns.template.tooltipX = am4core.percent(100);
          series.columns.template.tooltipY = am4core.percent(100);
          series.tooltip.pointerOrientation="horizontal"
          
  
          // Assign the filtered data to the series
          series.data = filteredData;
          chart.cursor = new am4charts.XYCursor();

       
          // Tooltip for moisture series
          series.tooltipText = `${mixID}\n Max:  {openValueY}  (%)\t Min:{valueY} (%)`;
          series.tooltip.label.fontSize = 10;
          
          series.tooltip.y=-10
      });
  
      chart.cursor = new am4charts.XYCursor();
  }, 100);
  
  
  
}
  parseToken() {
    let token = this.token;
    const tokenPayload = token.split(".")[1];
    const decodedPayload = atob(tokenPayload);
    const decodedPayloadJson = JSON.parse(decodedPayload);
    this.RoleId = decodedPayloadJson.role;
    this.usernamedisplay = decodedPayloadJson.username;
    this.OperatorRole = decodedPayloadJson.entity_id;
    this.selectedMIX = decodedPayloadJson.mix_id;
    this.selectedMixID = this.selectedMIX[0];
    this.selectedJobno = decodedPayloadJson.job_no;
    this.selectedJOBNO = this.selectedJobno[0];
    this.selectedPlanttype = decodedPayloadJson.plant_type;
    // this.selectDPlantType = this.selectedPlanttype[0];
    if (this.selectedPlanttype[0] == "TCII") {
      this.selectDPlantType = this.selectedPlanttype[0];
    } else {
      this.selectDPlantType = null;
    }
  }
  //  MixId list Dropdown Api Call
  getMIXidList() {
    let startDate = new Date(
      new Date(this.appliedDateFilters["start_date"]).setHours(0, 0, 0, 0)
    ).getTime();
    let endDate = new Date(
      new Date(this.appliedDateFilters["end_date"]).setHours(23, 59, 59, 999)
    ).getTime();
    this.apiCallsService
      .MIxidlist(startDate, endDate, this.selectDPlantType)
      .subscribe(
        (res) => {
          this.ListMixID = res;
          this.selectlistmixid = this.ListMixID[0].mix_id;
          this.selectonemixid = this.selectlistmixid[0];
        },
        (err) => {
          this.ListMixID = [];
          console.log(err);
        }
      );
  }
  changeMixId(types: any , action: string) {
    this.selectonemixid = [];
    this.ListMixID = types.target.value;
    this.selectonemixid = this.ListMixID;
    this.getUnifiedData();
    setTimeout(() => {
      this.getEneConsmpData();
    }, 300);
    
    
  }

  /* Api calls and Graphs functions for dropdown */

  getUnifiedData(){
    let startDate = new Date(
      new Date(this.appliedDateFilters["start_date"]).setHours(0, 0, 0, 0)
    ).getTime();
    let endDate = new Date(
      new Date(this.appliedDateFilters["end_date"]).setHours(23, 59, 59, 999)
    ).getTime();
    this.StatusType = "P";
    this.selectDPlantType = this.data.statusSelectedType;
    this.apiCallsService
      .HistoryProdData(
        startDate,
        endDate,
        this.selectonemixid,
        this.selectDPlantType,
        this.selectedJOB,
        this.StatusType
      )
      .subscribe(
        (res) => {
          this.ProdUnifiedData = res;
          this.ProductionHrs= this.ProdUnifiedData.OverallUtilization;
          this.ProdHours = this.ProdUnifiedData.ProductionDaily;
          this.ProdOEE = this.ProdUnifiedData.OEE;
          this.ProdTP= this.ProdUnifiedData.Throughput;
          this.ProdLoss= this.ProdUnifiedData.Losses;
          this.Mixlistdata=this.ProdUnifiedData.MixTonsRun;
          this.mixWasteData = this.ProdUnifiedData.Mix_Waste;
          this.ProdEC=this.ProdUnifiedData.GasConsumption;
         
          
         
          setTimeout(() => {
            this.getMixIdData();
            this.getmixidnames();
            this.DrawMixID();
          }, 100);
          setTimeout(() => {
            this.getGCdata();
            this.getGCdatanames();
            this.getGCtondatanames();
            if(this.StatusType == "NP"){
            this.DrawChartGCNP();
            } else{
              this.DrawChartGC();
            }
          }, 100);
  
          setTimeout(() => {
            this.DrawPvsNP();
            if(this.StatusType == "NP"){
              this.DrawNonProdGasQnty();
              } else{
                this.DrawProdGasQnty();
              }
            
            this.drawProdOEEchart();
            this.drawProdTPchart();
            this.drawProdlosschart();
            this.drawWastechart();
         }, 1000);
        
         
        },
        (err) => {
          this.ProdUnifiedData = [];
          console.log(err);
        }
      );
  }

  getEneConsmpData() {
    let startDate = new Date(
      new Date(this.appliedDateFilters["start_date"]).setHours(0, 0, 0, 0)
    ).getTime();
    let endDate = new Date(
      new Date(this.appliedDateFilters["end_date"]).setHours(23, 59, 59, 999)
    ).getTime();
    this.apiCallsService
      .EnergyConsumptionGraph(
        startDate,
        endDate,
        this.selectonemixid,
        this.selectDPlantType,
        this.selectedJOB,
        this.StatusType
      )
      .subscribe(
        (res) => {
          this.EnergyUnifiedData = res;
          this.ProdHours = this.EnergyUnifiedData.ProductionDaily;
          this.ProdEC = this.EnergyUnifiedData.GasConsumption;
          this.ThroughputGas = this.EnergyUnifiedData.Throughput_GasConsumption;
          console.log("log", this.ThroughputGas,  this.ProdEC )
          this.GasDrumData =  this.EnergyUnifiedData.DrumshellTemp_Comparison.final_data;
          this.GasAmbData =  this.EnergyUnifiedData.Ambient_Temp_comparison.final_data;
          
    
     
         
        
          setTimeout(() => {
            this.getGCdata();
            this.getGCdatanames();
            this.getGCtondatanames();
            if (this.StatusType == "NP") {
              this.DrawChartGCNP();
              this.DrawNonProdGasQnty();
            } else {
              this.DrawChartGC();
              this.DrawProdGasQnty();
            }
          }, 100);
          setTimeout(() => {
            this.getTPdata();
            this.getTPdatanames();
            this.getTroughputdatanames();
            setTimeout(() => {
              this.DrawChartTP();
            }, 300);
          
          }, 1200);

       
          setTimeout(() => {
            this.mergeData();
            setTimeout(() => {
              this.getGasAmbDrum();
              this.getGasAmbDrumnames();
              this.getDrumDataname();
              this.getAmbDataname();
            }, 100);
           
            setTimeout(() => {
              this.DrawChartGAD();
            }, 300);
          }, 1000);
        },
        (err) => {
          this.EnergyUnifiedData = [];
          console.log(err);
          
        }
      );
  }

  mergeData() {
    const mergedMap = new Map<string, any>();
    
    // Merge GasDrumData
    this.GasDrumData.forEach(dataArray => {
      dataArray.forEach(data => {
        mergedMap.set(data.obs_time_real, { ...mergedMap.get(data.obs_time_real), ...data });
      });
    });
    
    // Merge GasAmbData
    this.GasAmbData.forEach(dataArray => {
      dataArray.forEach(data => {
        mergedMap.set(data.obs_time_real, { ...mergedMap.get(data.obs_time_real), ...data });
      });
    });

    // Convert the Map back to an array
    this.mergedData = Array.from(mergedMap.values());
    // console.log("this.mergedData",     this.mergedData)
  }

  getGasAmbDrum(){
    this.GADdata = [];
    let FinalGAD = this.GasDrumData;
    for (let dataItemgad of FinalGAD) {
      this.GADdata.push(dataItemgad[0]);
    }
    // console.log("this.GADdata;", this.GADdata )
  }


  getGasAmbDrumnames(){
    this.GADIdnames = [];
    let finalgadData = this.GasDrumData;
    for (let dataItemgad of finalgadData) {
      let GADelements = Object.keys(dataItemgad[0]);
      for (let element of GADelements) {
        if (
          element != "obs_time_real" &&
          element != "NoMix" &&
          element != "drum_shell_temp" &&
          element != "date" &&
          element != "hourly" && 
          element != "ambient_temp"
        ) {
          if (!this.isItemPresentinListgc(this.GADIdnames, element)) {
            this.GADIdnames.push(element);
          }
        }
      }
    }
    // console.log("this.GADIdnames;", this.GADIdnames )
  }

  getDrumDataname(){
    this.DrumName = [];
    let FinalDrumdata = this.GasDrumData;
    for (let dataDrum of FinalDrumdata){
      let GADelements = Object.keys(dataDrum[0]);
      for (let element of GADelements) {
        if (
          element == "drum_shell_temp" 
        ) {
          if (!this.isItemPresentinListGAD(this.DrumName, element)) {
            this.DrumName.push(element);
          }
        }
      }
     
    }
    // console.log("this.DrumName;", this.DrumName )
  }

  getAmbDataname(){
    this.AmbName = [];
    let FinalAmbdata = this.GasAmbData;
    for (let dataAmb of FinalAmbdata){
      let GADelements = Object.keys(dataAmb[0]);
      for (let element of GADelements) {
        if (
          element === "ambient_temp" 
        ) {
          if (!this.isItemPresentinListGAD(this.AmbName, element)) {
            this.AmbName.push(element);
          }
        }
      }
    }
    // console.log("this.AmbName;", this.AmbName )
  }

  isItemPresentinListGAD(list1, item1) {
    for (let i = 0; i < list1.length; i++) {
      let listItem1 = list1[i];
      if (listItem1 === item1) {
        return true;
      }
    }
    return false;
  }


  getTPdata() {
    this.TPdata = [];
    let FinalTPData = this.ThroughputGas.final_data;
    for (let dataItemTP of FinalTPData) {
      this.TPdata.push(dataItemTP[0]);
    }
  }
  getTPdatanames() {
    this.TPIdNames = [];
    let FinalTPData = this.ThroughputGas.final_data;
    for (let dataItemTP of FinalTPData) {
      let TPelements = Object.keys(dataItemTP[0]);
      for (let element of TPelements) {
        if (
          element != "obs_time_real" &&
          element != "NoMix" &&
          element != "throughput" &&
          element != "date" &&
          element != "hourly"
        ) {
          if (!this.isItemPresentinListTP(this.TPIdNames, element)) {
            this.TPIdNames.push(element);
          }
        }
      }
    }
   
  }
  getTroughputdatanames() {
    this.TPName = [];
    let FinalTPnameData = this.ThroughputGas.final_data;
    for (let dataItemTP of FinalTPnameData) {
      let TPtonelements = Object.keys(dataItemTP[0]);
      for (let element of TPtonelements) {
        if (element == "throughput") {
          if (!this.isItemPresentinListgc(this.TPName, element)) {
            this.TPName.push(element);
          }
        }
      }
    }
   
  }
  isItemPresentinListTP(list1, item1) {
    for (let i = 0; i < list1.length; i++) {
      let listItem1 = list1[i];
      if (listItem1 === item1) {
        return true;
      }
    }
    return false;
  }


  getMixIdData() {
    this.mixIdData = [];
    let FinalData = this.Mixlistdata.final_data;
    for (let dataItem of FinalData) {
      this.mixIdData.push(dataItem[0]);
    }
  }
  getmixidnames() {
    this.MixIdNames = [];

    let FinalData = this.Mixlistdata.final_data;
    for (let dataItem of FinalData) {
      let Mixelements = Object.keys(dataItem[0]);

      for (let element of Mixelements) {
        if (
          element != "obs_time_real" &&
          element != "NoMix" &&
          element != "date" &&
          element != "hourly"
        ) {
          if (!this.isItemPresentinList(this.MixIdNames, element)) {
            this.MixIdNames.push(element);
          }
        }
      }
    }
  }
  isItemPresentinList(list, item) {
    for (let i = 0; i < list.length; i++) {
      let listItem = list[i];
      if (listItem === item) {
        return true;
      }
    }
    return false;
  }

  // Gas Consumption Api call

  getGCdata() {
    this.GCfdata = [];
    let FinalGCData = this.ProdEC.final_data;
    for (let dataItemgc of FinalGCData) {
      this.GCfdata.push(dataItemgc[0]);
    }
  }
  getGCdatanames() {
    this.GCIdNames = [];
    let FinalgcData = this.ProdEC.final_data;
    for (let dataItemgc of FinalgcData) {
      let GCelements = Object.keys(dataItemgc[0]);
      for (let element of GCelements) {
        if (
          element != "obs_time_real" &&
          element != "NoMix" &&
          element != "gas_per_ton" &&
          element != "date" &&
          element != "hourly"
        ) {
          if (!this.isItemPresentinListgc(this.GCIdNames, element)) {
            this.GCIdNames.push(element);
          }
        }
      }
    }
  }
  getGCtondatanames() {
    this.GCtonName = [];
    let FinalgctonData = this.ProdEC.final_data;
    for (let dataItemgc of FinalgctonData) {
      let GCtonelements = Object.keys(dataItemgc[0]);
      for (let element of GCtonelements) {
        if (element == "gas_per_ton") {
          if (!this.isItemPresentinListgc(this.GCtonName, element)) {
            this.GCtonName.push(element);
          }
        }
      }
    }
  }
  isItemPresentinListgc(list1, item1) {
    for (let i = 0; i < list1.length; i++) {
      let listItem1 = list1[i];
      if (listItem1 === item1) {
        return true;
      }
    }
    return false;
  }


  // Math.round(x)
  keysnValues() {
    Object.entries(this.data.Top3MixIdnames).forEach(([key, values]) => {
      this.keyValuePairs.push({ key, values });
    });
  }

  getunionAlert() {
    this.UnionAlertsData = this.data.Alertdata;
  }

  /* Popup Graphs */

  // Production vs Non production chart Full View (opeartion And Non Productive)
  DrawPvsNP() {
    setTimeout(() => {
      let ref = this;
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("chartPNP", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 0;
      chart.paddingLeft = 15;
      // Add data
      chart.data = ref.data.graphData;
      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.title.text = "Date";
      categoryAxis.title.fill = am4core.color("#FFF");
      // categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.labels.template.fontSize = 12;
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      categoryAxis.title.fontSize = 12;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.min = 0;
      valueAxis.marginRight = 25;
      valueAxis.title.text = "Hours (Hrs)";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 10;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
      // Create series

      // Set up series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.name = "Productive";
      series.dataFields.valueY = "p_run_time";
      series.dataFields.categoryX = "obs_time_real";
      series.sequencedInterpolation = true;
      series.stroke = am4core.color("#55FF5C");
      // series.strokeWidth = 3;
      series.fill = am4core.color("#55FF5C");
      series.legendSettings.labelText = "[font-size:12px {stroke}]{name}[/]";
      let series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.name = "Non-Productive";
      series1.dataFields.valueY = "np_run_time";
      series1.dataFields.categoryX = "obs_time_real";
      series1.sequencedInterpolation = true;
      series1.legendSettings.labelText = "[font-size:12px {stroke}]{name}[/]";
      series1.stroke = am4core.color("#FFBF00");
      series1.fill = am4core.color("#FFBF00");
      // Make it stacked
      series.stacked = true;
      series1.stacked = true;
      // Configure columns
      series.columns.template.width = am4core.percent(30);
      series.tooltipText = " [font-size: 12px]Productive:{valueY.formatNumber('#.0')}(Hrs)";

      series1.columns.template.width = am4core.percent(30);
      series1.tooltipText = " [font-size: 12px]Non-Productive: {valueY.formatNumber('#.0')}(Hrs)";

      // Add label
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      // labelBullet.label.text = "{valueY}";
      labelBullet.locationY = 0.5;
      labelBullet.label.hideOversized = true;

      // Legend
      chart.legend = new am4charts.Legend();
      chart.legend.useDefaultMarker = true;
      chart.legend.fontSize = 10;
      chart.legend.labels.template.fill = am4core.color('#fff');
      chart.legend.position = "bottom";
      chart.legend.contentAlign = "center";
      chart.legend.itemContainers.template.width = am4core.percent(20);
      chart.legend.markers.template.width = 16;
      chart.legend.markers.template.height = 16;
    }, 150);
  }
  // Production vs Gas Vs Qnty chart Full View
  DrawProdGasQnty() {
    setTimeout(() => {
      let ref = this;

      am4core.useTheme(am4themes_animated);

      // Themes end

      // Create chart instance
      let chart = am4core.create("ProdHoursDiv1", am4charts.XYChart);
      chart.logo.disabled = true;

      var chartData = this.ProdHours;
      chart.data = chartData;

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");

            // Create scientific notation formatter
            const scientificFormatter = new am4core.NumberFormatter();
            scientificFormatter.numberFormat = "#.#a";
            scientificFormatter.bigNumberPrefixes = [
              { "number": 1e3, "suffix": "K" },
              { "number": 1e6, "suffix": "M" },
              { "number": 1e9, "suffix": "B" },
              { "number": 1e12, "suffix": "T" }
            ];

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      // valueAxis.maxPrecision = 0;
      valueAxis.title.text = "Productive (Hrs)";
      valueAxis.title.fontSize = "12px";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.min = 0;
      valueAxis.renderer.minGridDistance = 35;
      valueAxis.cursorTooltipEnabled = false;

      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      // valueAxis2.maxPrecision = 0;
      valueAxis2.title.text = "Quantity (Tons)";
      valueAxis2.title.fontSize = "12px";
      valueAxis2.title.fill = am4core.color("#FFF");
      valueAxis2.cursorTooltipEnabled = false;
      valueAxis2.renderer.opposite = true;
      valueAxis2.min = 0;
      valueAxis2.syncWithAxis = valueAxis;
      valueAxis2.renderer.minGridDistance = 30;
      valueAxis2.renderer.labels.template.fontSize = 12;
      valueAxis2.renderer.labels.template.fill = am4core.color("#fff");
      let valueAxis3 = chart.yAxes.push(new am4charts.ValueAxis());

      valueAxis3.title.text = "Gas Consp PerTon(BTU)";
      valueAxis3.title.fontSize = "10px";
      valueAxis3.title.fill = am4core.color("#FFF");
      valueAxis3.cursorTooltipEnabled = false;
      valueAxis3.renderer.opposite = true;
      valueAxis3.min = 0;
      
      valueAxis3.syncWithAxis = valueAxis;
      valueAxis3.renderer.labels.template.fontSize = 12;
      valueAxis3.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis3.renderer.minGridDistance = 40;
      valueAxis3.renderer.grid.template.disabled = true;
      valueAxis3.renderer.labels.template.fontSize = 10;
      valueAxis3.renderer.labels.template.fill = am4core.color("#fff");
      
      // Use a label function to customize label text
      valueAxis3.numberFormatter = scientificFormatter;
      
      
      
      
      /* Create series */
      let columnSeries = chart.series.push(new am4charts.ColumnSeries());

      columnSeries.dataFields.valueY = "p_run_time";
      columnSeries.dataFields.categoryX = "obs_time_real";
      columnSeries.legendSettings.labelText = "[{stroke}]{name}[/]";
      
      columnSeries.tooltipText = " [font-size: 12px] Productive:{valueY.formatNumber('#.0')}(Hrs)";
      columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
      columnSeries.columns.template.propertyFields.stroke = "stroke";
      columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
      columnSeries.columns.template.stroke = am4core.color("#55FF5C");
      columnSeries.columns.template.fill = am4core.color("#55FF5C");
      // columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
      columnSeries.tooltip.label.textAlign = "middle";
      columnSeries.name = "Productive (Hrs)";
      columnSeries.legendSettings.valueText =
        " [#55FF5C font-size: 10px] Productive[/]";
      columnSeries.strokeWidth = 3;
      // series.tensionX = 0.9;
      columnSeries.stroke = am4core.color("#55FF5C");
      columnSeries.fill = am4core.color("#55FF5C");
      columnSeries.legendSettings.labelText = " [{stroke}{name}][/]";
      columnSeries.columns.template.width = am4core.percent(30);
      let lineSeries = chart.series.push(new am4charts.LineSeries());
      lineSeries.dataFields.valueY = "mix_10";
      lineSeries.dataFields.categoryX = "obs_time_real";
      // lineSeries.tooltipText = "Quantity" + `:{${"mix_10"}}`;
      lineSeries.yAxis = valueAxis2;
      lineSeries.stroke = am4core.color("#32CD30");
      lineSeries.fill = am4core.color("#32CD30");
      lineSeries.strokeWidth = 3;
      lineSeries.tensionX = 0.9;
      lineSeries.propertyFields.strokeDasharray = "lineDash";
      lineSeries.tooltip.label.textAlign = "middle";
      lineSeries.tooltipText = "  [font-size: 12px]Quantity:{valueY.formatNumber('#.0')}(Tons)";
      lineSeries.name = "Quantity (Tons) ";
      lineSeries.legendSettings.valueText =
        "[#32CD30 font-size:10px] Quantity[/]";
      lineSeries.legendSettings.labelText = "[{stroke}{name}][/]";
      let lineSeries1 = chart.series.push(new am4charts.LineSeries());
      lineSeries1.dataFields.valueY = "act_qty_cng_perton";
      lineSeries1.dataFields.categoryX = "obs_time_real";
      // lineSeries1.tooltipText = "Energy" + `:{${"act_qty_cng_perton"}}`;
      lineSeries1.yAxis = valueAxis3;
      lineSeries1.stroke = am4core.color("#D6E865");
      lineSeries1.fill = am4core.color("#D6E865");
      lineSeries1.strokeWidth = 3;
      lineSeries1.tensionX = 0.9;
      lineSeries1.propertyFields.strokeDasharray = "lineDash";
      lineSeries1.tooltip.label.textAlign = "middle";
      lineSeries1.tooltipText =
        "  [font-size: 12px]GC perTon(BTU):{valueY.formatNumber('#.00')}";
      lineSeries1.name = "Gas Consumption (m3)";
      lineSeries1.legendSettings.valueText =
        "[#D6E865 font-size:10px ] Gas Consumption [/]";
      lineSeries1.legendSettings.labelText = "[{stroke}{name}][/]";
      let bullet = lineSeries.bullets.push(new am4charts.Bullet());
      bullet.fill = am4core.color("#32CD30"); // tooltips grab fill from parent by default
      let circle = bullet.createChild(am4core.Circle);
      circle.radius = 4;

      circle.strokeWidth = 3;
      let bullet1 = lineSeries1.bullets.push(new am4charts.Bullet());
      bullet1.fill = am4core.color("#D6E865"); // tooltips grab fill from parent by default
      let circle1 = bullet1.createChild(am4core.Circle);
      circle1.radius = 4;

      circle1.strokeWidth = 3;
      chart.legend = new am4charts.Legend();
      chart.legend.position = "bottom";

      var title = chart.titles.create();
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = 20;
      resetLabel.y = -30;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();
      resetLabel.events.on("hit", function (ev) {
        resetLabel.hide();
        title.hide();
        // ev.target.baseSprite.titles.getIndex(0).text = "Throughput";
        chart.data = chartData;
      });
      interface DataContext {
        hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
        obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
        // Add other properties if necessary
      }
      columnSeries.columns.template.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text =
              " Hourly Data " + " " + "-" + " " + dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
          }
        },
        this
      );
      lineSeries.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text = dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
          }
        },
        this
      );
      lineSeries1.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text = dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
          }
        },
        this
      );

      // Add cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;
      // chart.cursor.yAxis.disabled = true;
    }, 100);
  }
  // OEE chart Full View
  drawProdOEEchart() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
      // Themes end
      // Create chart instance
      var chart = am4core.create("OEEindex", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      chart.marginRight = 15;
      chart.paddingLeft = 10;
      chart.marginLeft = 10;

      var chartData = this.ProdOEE;

      chart.data = chartData;

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.title.fontSize = 12;
      categoryAxis.title.fill = am4core.color("#FFF");
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;

      const scientificFormatter = new am4core.NumberFormatter();
                  scientificFormatter.numberFormat = "#.#a";
                  scientificFormatter.bigNumberPrefixes = [
                    { "number": 1e3, "suffix": "K" },
                    { "number": 1e6, "suffix": "M" },
                    { "number": 1e9, "suffix": "B" },
                    { "number": 1e12, "suffix": "T" }
                  ];
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    
      valueAxis.marginRight = 30;
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.title.text = "Energy Consumption (BTU)";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.numberFormatter = scientificFormatter;

      // Create series
      var series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "production_gas";
      series.dataFields.categoryX = "obs_time_real";
      series.name = "EC Production";
      series.tooltipText = " [font-size: 12px]{name}: {valueY.formatNumber('#.')}(BTU)[/]";
      series.columns.template.width = am4core.percent(20);
      series.columns.template.propertyFields.url = "url";
      series.strokeWidth = 3;
      series.stroke = am4core.color("#55FF5C");
      series.fill = am4core.color("#55FF5C");
      series.legendSettings.labelText = "[{stroke}]{name}[/]";
      series.clustered = false; // Ensures bars are side-by-side
      series.columns.template.dx = -7;
      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.dataFields.valueY = "non_production_gas";
      series1.dataFields.categoryX = "obs_time_real";
      series1.name = "EC Idle";
      series1.tooltipText = " [font-size: 12px]{name}: {valueY.formatNumber('#.')}(BTU)[/]";
      series1.columns.template.width = am4core.percent(20);
      series1.columns.template.propertyFields.url = "url";
      series1.stroke = am4core.color("#D6E865");
      series1.fill = am4core.color("#D6E865");
      series1.legendSettings.labelText = "[{stroke}]{name}[/]";
      series1.clustered = false; // Ensures bars are side-by-side
      series1.columns.template.dx = 7;
      var title = chart.titles.create();
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = 20;
      resetLabel.y = -20;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();
      resetLabel.events.on(
        "hit",
        function (ev) {
          resetLabel.hide();
          title.hide();
          // ev.target.baseSprite.titles.getIndex(0).text = "Throughput";
          chart.data = chartData;
          this.IsDropdownTrue = true;
        },
        this
      );

      interface DataContext {
        hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
        obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
        // Add other properties if necessary
      }

      series.columns.template.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text =
              " Hourly OEE " + " " + "-" + " " + dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
            this.IsDropdownTrue = false;
          }
        },
        this
      );

      series1.columns.template.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text =
              " Hourly OEE " + " " + "-" + " " + dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
            this.IsDropdownTrue = false;
          }
        },
        this
      );
    }, 100);
  }
  // Throughput chart Full View
  drawProdTPchart() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
      // Themes end
      // Create chart instance
      var chart = am4core.create("TPgraph", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      chart.marginRight = 15;
      chart.paddingLeft = 10;
      chart.marginLeft = 10;
      var chartData = this.ProdTP;
      chart.data = chartData;

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.title.fontSize = 12;
      categoryAxis.title.fill = am4core.color("#FFF");
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.marginRight = 30;
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.title.text = "Tons";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
      // Create series

      var series = chart.series.push(new am4charts.ColumnSeries());
              series.dataFields.valueY = "throughput";
              series.dataFields.categoryX = "obs_time_real";
              series.name = "Throughput";
              series.columns.template.tooltipText =
                "[font-size: 12px]{name}: {valueY.formatNumber('#.0')}(Tons)[/]";
              series.columns.template.width = am4core.percent(20); // Adjusted width to fit bars side by side
              series.columns.template.propertyFields.url = "url";
              series.strokeWidth = 3;
              series.stroke = am4core.color("#55FF5C");
              series.fill = am4core.color("#55FF5C");
              series.legendSettings.labelText = "[{stroke}]{name}[/]";
              series.clustered = false; // Ensures bars are side-by-side
              series.columns.template.dx = -7;

      var series1 = chart.series.push(new am4charts.ColumnSeries());
      series1.dataFields.valueY = "target_tph";
      series1.dataFields.categoryX = "obs_time_real";
      series1.name = "Target Mix Tons";
      series1.tooltipText = "[font-size: 12px]{name}: {valueY.formatNumber('#.0')}(Tons)[/]";
      series1.columns.template.width = am4core.percent(20); // Adjusted width to fit bars side by side
      series1.columns.template.propertyFields.url = "url";
      series1.stroke = am4core.color("#D6E865");
      series1.fill = am4core.color("#D6E865");
      series1.legendSettings.labelText = "[{stroke}]{name}[/]";
      series1.clustered = false; // Ensures bars are side-by-side
      series1.columns.template.dx = 7;
      var title = chart.titles.create();
      // title.text = "Throughput";
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = 20;
      resetLabel.y = -20;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();

      resetLabel.events.on(
        "hit",
        function (ev) {
          resetLabel.hide();
          title.hide();
          chart.data = chartData;
          this.IsDropdownTrue = true;
        },
        this
      );
      interface DataContext {
        hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
        obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
        // Add other properties if necessary
      }

      series.columns.template.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text =
              " Hourly Throughput" +
              " " +
              "-" +
              " " +
              dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();

            this.IsDropdownTrue = false;
          }
        },
        this
      );
    }, 100);
  }
  // Utilization Losses chart Full View
  drawProdlosschart() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
      // Themes end
      // Create chart instance
      var chart = am4core.create("ProdlossgraphD", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      chart.marginRight = 15;
      chart.paddingLeft = 10;
      chart.marginLeft = 10;
      var chartData = this.ProdLoss;
      chart.data = chartData;

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.title.fontSize = 12;
      categoryAxis.title.fill = am4core.color("#FFF");
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;

      const scientificFormatter = new am4core.NumberFormatter();
                  scientificFormatter.numberFormat = "#.#a";
                  scientificFormatter.bigNumberPrefixes = [
                    { "number": 1e3, "suffix": "K" },
                    { "number": 1e6, "suffix": "M" },
                    { "number": 1e9, "suffix": "B" },
                    { "number": 1e12, "suffix": "T" }
                  ];

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.marginRight = 30;
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.title.text = "Losses (Tons)";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.numberFormatter = scientificFormatter;

      // Create series

      var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "losses";
            series.dataFields.categoryX = "obs_time_real";
            series.name = "Utilization Losses ";
            series.columns.template.tooltipText =
              "[font-size: 12px]{name}:{valueY.formatNumber('#.')}(Tons)[/]";
            series.columns.template.width = am4core.percent(30);
            series.columns.template.propertyFields.url = "url";
            series.strokeWidth = 3;
            series.stroke = am4core.color("#55FF5C");
            series.fill = am4core.color("#55FF5C");
            series.legendSettings.labelText = "[{stroke}]{name}[/]";

      var title = chart.titles.create();
      // title.text = "Throughput";
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = -30;
      resetLabel.y = -30;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();
      resetLabel.events.on(
        "hit",
        function (ev) {
          resetLabel.hide();
          title.hide();
          // ev.target.baseSprite.titles.getIndex(0).text = "Throughput";
          chart.data = chartData;
          this.IsDropdownTrue = true;
        },
        this
      );
      interface DataContext {
        hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
        obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
        // Add other properties if necessary
      }

      series.columns.template.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text =
              " Hourly Losses" + " " + "-" + " " + dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
            this.IsDropdownTrue = false;
          }
        },
        this
      );
    }, 100);
  }
   drawWastechart() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
      // Themes end
      // Create chart instance
      var chart = am4core.create("drawwasteChart", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      chart.marginRight = 15;
      chart.paddingLeft = 10;
      chart.marginLeft = 10;
      var chartData = this.mixWasteData;
      chart.data = chartData;

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.title.fontSize = 12;
      categoryAxis.title.fill = am4core.color("#FFF");
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;

      const scientificFormatter = new am4core.NumberFormatter();
                  scientificFormatter.numberFormat = "#.#a";
                  scientificFormatter.bigNumberPrefixes = [
                    { "number": 1e3, "suffix": "K" },
                    { "number": 1e6, "suffix": "M" },
                    { "number": 1e9, "suffix": "B" },
                    { "number": 1e12, "suffix": "T" }
                  ];

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.marginRight = 30;
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.title.text = "Mix Waste (Tons)";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.numberFormatter = scientificFormatter;

      // Create series

      var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "mix_rejected";
            series.dataFields.categoryX = "obs_time_real";
            series.name = "Mix Waste";
            series.columns.template.tooltipText =
              "[font-size: 12px]{name}:{valueY.formatNumber('#.')}(Tons)[/]";
            series.columns.template.width = am4core.percent(30);
            series.columns.template.propertyFields.url = "url";
            series.strokeWidth = 3;
            series.stroke = am4core.color("#55FF5C");
            series.fill = am4core.color("#55FF5C");
            series.legendSettings.labelText = "[{stroke}]{name}[/]";

      var title = chart.titles.create();
      // title.text = "Throughput";
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = -30;
      resetLabel.y = -30;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();
      resetLabel.events.on(
        "hit",
        function (ev) {
          resetLabel.hide();
          title.hide();
          // ev.target.baseSprite.titles.getIndex(0).text = "Throughput";
          chart.data = chartData;
          this.IsDropdownTrue = true;
        },
        this
      );
      interface DataContext {
        hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
        obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
        // Add other properties if necessary
      }

      series.columns.template.events.on(
        "hit",
        function (ev) {
          const dataContext = ev.target.dataItem.dataContext as DataContext; // Define the type of dataContext explicitly
          if (Array.isArray(dataContext.hourly)) {
            // update the chart title
            chart.titles.getIndex(0).text =
              " Hourly Losses" + " " + "-" + " " + dataContext.obs_time_real;
            // set the hourly data for the clicked Day
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
            this.IsDropdownTrue = false;
          }
        },
        this
      );
    }, 100);
  }
  // Gas Consumption chart Full View ECgraph
  DrawChartGC() {
    setTimeout(() => {
      let ref = this;
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("ECgraph", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      chart.legend = new am4charts.Legend();
      chart.legend.position = "bottom";
    
      // Add data
      var chartData = this.GCfdata;
      chart.data = chartData;
    
      chart.colors.list = [
        am4core.color("#00ff00"),
        am4core.color("#03c03c"),
        am4core.color("#2e8b57"),
        am4core.color("#3fff00"),
        am4core.color("#059033"),
        am4core.color("#009900"),
        am4core.color("#008000"),
        am4core.color("#195905"),
        am4core.color("#8fd400"),
        am4core.color("#76ff7a"),
        am4core.color("#50c878"),
        am4core.color("#00ff7f"),
      ];
    
      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.title.fontSize = 12;
      categoryAxis.title.fill = am4core.color("#FFF");
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
    
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;
      chart.cursor.behavior = "none";

            // Create scientific notation formatter
            const scientificFormatter = new am4core.NumberFormatter();
            scientificFormatter.numberFormat = "#.#a";
            scientificFormatter.bigNumberPrefixes = [
              { "number": 1e3, "suffix": "K" },
              { "number": 1e6, "suffix": "M" },
              { "number": 1e9, "suffix": "B" },
              { "number": 1e12, "suffix": "T" }
            ];
    
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.marginRight = 50;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.min = 0;
      valueAxis.title.text = "Gas Consumption(BTU)";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 12;
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.renderer.minGridDistance = 45;
      valueAxis.numberFormatter = scientificFormatter;
      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      // valueAxis2.maxPrecision = 0;
      valueAxis2.title.text = "Gas Consumption per Ton (BTU)";
      valueAxis2.title.fontSize = "10px";
      valueAxis2.title.fill = am4core.color("#FFF");
      valueAxis2.cursorTooltipEnabled = false;
      valueAxis2.renderer.opposite = true;
      valueAxis2.min = 0;
      // valueAxis2.max= 0.5;
      valueAxis2.syncWithAxis = valueAxis;
      valueAxis2.renderer.labels.template.fontSize = 12;
      valueAxis2.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis2.renderer.minGridDistance = 45;


      valueAxis2.numberFormatter = scientificFormatter;
            
            
      var title = chart.titles.create();
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = -30;
      resetLabel.y = -30;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();
      resetLabel.events.on(
        "hit",
        function (ev) {
          resetLabel.hide();
          title.hide();
    
          chart.data = chartData;
        },
        this
      );
    
      interface DataContext {
        hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
        obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
        // Add other properties if necessary
      }
    
      // Create series
      function createSeries(field, name) {
        // Set up series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "obs_time_real";
        series.sequencedInterpolation = true;
        series.stacked = true;
        series.strokeWidth = 1;
        series.legendSettings.labelText = " [{stroke} {name}][/]";
        series.legendSettings.valueText = "[#fff font-size:12px ] {name}[/]";
    
        // Configure columns
        series.columns.template.width = am4core.percent(40);
        // series.tooltipText = "{name}\n{valueY.formatNumber('#.')}";
        series.tooltipText =
          " [font-size: 12px]{name}\n{valueY.formatNumber('#.')}" + " " + "(BTU)";
        return series;
      }
      for (let i = 0; i < this.GCIdNames.length; i++) {
        let GCMixIdName = this.GCIdNames[i];
        let series = createSeries(GCMixIdName, GCMixIdName);
        series.columns.template.events.on("hit", (ev) => {
          const dataContext = ev.target.dataItem.dataContext as DataContext;
          if (Array.isArray(dataContext.hourly)) {
            chart.titles.getIndex(0).text =
              " Hourly MixID " + " " + "-" + " " + dataContext.obs_time_real;
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
          }
        });
      }
    
      function createSeries1(field, name) {
        // Set up series
        let series1 = chart.series.push(new am4charts.LineSeries());
        series1.name = name;
        series1.dataFields.valueY = field;
        series1.dataFields.categoryX = "obs_time_real";
        series1.yAxis = valueAxis2;
        series1.stroke = am4core.color("#D6E865");
        series1.fill = am4core.color("#D6E865");
    
        series1.tensionX = 0.9;
        series1.propertyFields.strokeDasharray = "lineDash";
        series1.strokeWidth = 3;
        series1.legendSettings.labelText = " [{stroke} {name}][/]";
        series1.legendSettings.valueText = "[#fff font-size:12px ] Gas Consumption per Ton (BTU)[/]";

    
        // Configure columns
        series1.tooltipText = " [font-size: 12px]GC :{valueY.formatNumber('#.00')}(per Ton)";
        let bullet1 = series1.bullets.push(new am4charts.Bullet());
        bullet1.fill = am4core.color("#D6E865"); // tooltips grab fill from parent by default
        let circle1 = bullet1.createChild(am4core.Circle);
        circle1.radius = 4;
        circle1.strokeWidth = 3;
        return series1;
      }
      for (let i = 0; i < this.GCtonName.length; i++) {
        let GCMixtonIdName = this.GCtonName[i];
        createSeries1(GCMixtonIdName, GCMixtonIdName);
      }
    }, 150);
  }
  // Non Productive vs Gas Consumption chart Full View
  DrawNonProdGasQnty() {
    setTimeout(() => {
      let ref = this;
      am4core.useTheme(am4themes_animated);
      // Themes end
      // Create chart instance
      let chart = am4core.create("NPDiv", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.data = this.ProdHours;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      // dateAxis.baseInterval = { timeUnit: "day", count: 1 },
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 40;
      dateAxis.renderer.labels.template.fontSize = 12;
      dateAxis.title.fill = am4core.color("#FFF");
      dateAxis.renderer.labels.template.fill = am4core.color("#fff");

      

      /* Create value axis */
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.maxPrecision = 0;
      valueAxis.title.text = "Non Productive (Hrs)";
      valueAxis.title.fontSize = "12px";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.cursorTooltipEnabled = false;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.min = 0;
      valueAxis.cursorTooltipEnabled = false;
      

      let valueAxis3 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis3.maxPrecision = 0;
      valueAxis3.title.text = "Gas Consumption (BTU)";
      valueAxis3.title.fontSize = "12px";
      valueAxis3.title.fill = am4core.color("#FFF");
      valueAxis3.cursorTooltipEnabled = false;
      valueAxis3.renderer.opposite = true;
      valueAxis3.min = 0;
      valueAxis3.syncWithAxis = valueAxis;
      valueAxis3.renderer.labels.template.fontSize = 12;
      valueAxis3.renderer.labels.template.fill = am4core.color("#fff");
      /* Create series */
      let columnSeries = chart.series.push(new am4charts.ColumnSeries());

      columnSeries.dataFields.valueY = "np_run_time";
      columnSeries.dataFields.dateX = "obs_time_real";
      // columnSeries.stroke = am4core.color("#10C8F8");

      columnSeries.tooltipText = " [font-size: 12px]Non Productive" + `:{${"np_run_time"}}(Hrs)`;
      columnSeries.legendSettings.labelText = "[{stroke}]{name}[/]";
     
      columnSeries.tooltipText =
        " [font-size: 12px] Non Productive :{valueY.formatNumber('#.0')}";
      columnSeries.columns.template.propertyFields.fillOpacity = "fillOpacity";
      columnSeries.columns.template.propertyFields.stroke = "stroke";
      columnSeries.columns.template.propertyFields.strokeWidth = "strokeWidth";
      columnSeries.columns.template.stroke = am4core.color("#FFBF00");
      columnSeries.columns.template.fill = am4core.color("#FFBF00");
      // columnSeries.columns.template.propertyFields.strokeDasharray = "columnDash";
      columnSeries.tooltip.label.textAlign = "middle";
      columnSeries.name = "Non Productive ";
      columnSeries.legendSettings.valueText =
        " [#FFBF00 font-size: 9px] {name}[/]";
      columnSeries.strokeWidth = 3;
      // series.tensionX = 0.9;
      columnSeries.stroke = am4core.color("#55FF5C");
      columnSeries.fill = am4core.color("#55FF5C");
      columnSeries.legendSettings.labelText = " [{stroke} {name}][/]";
      columnSeries.columns.template.width = am4core.percent(30);

      
      let lineSeries1 = chart.series.push(new am4charts.LineSeries());
      lineSeries1.dataFields.valueY = "act_qty_cng";
      lineSeries1.dataFields.dateX = "obs_time_real";
      // lineSeries1.tooltipText = "Gas consumption" + `:{${"act_qty_cng_perton"}}`;
      // FFBF00
      lineSeries1.yAxis = valueAxis3;
      lineSeries1.stroke = am4core.color("#55FF5C");
      lineSeries1.fill = am4core.color("#55FF5C");
      lineSeries1.strokeWidth = 3;
      lineSeries1.tensionX = 0.9;
      lineSeries1.propertyFields.strokeDasharray = "lineDash";
      lineSeries1.tooltip.label.textAlign = "middle";
      lineSeries1.tooltipText =
        " [font-size: 12px] Gas Consumption:{valueY.formatNumber('#.00')}(BTU)";
      lineSeries1.name = "Gas Consumption ";
      lineSeries1.legendSettings.valueText =
        "[#55FF5C font-size: 9px] {name}[/]";
      lineSeries1.legendSettings.labelText = "[{stroke} {name}][/]";

      
      let bullet1 = lineSeries1.bullets.push(new am4charts.Bullet());
      bullet1.fill = am4core.color("#55FF5C"); // tooltips grab fill from parent by default
     
      let circle1 = bullet1.createChild(am4core.Circle);
      circle1.radius = 4;
      // circle.fill = am4core.color("");
      circle1.strokeWidth = 3;

      chart.legend = new am4charts.Legend();
      chart.legend.position = "bottom";
      // chart.legend.fill = am4core.color("#fff");

      // Add cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      chart.cursor.lineY.disabled = true;
      // // chart.cursor.yAxis.disabled = true;
      chart.numberFormatter.numberFormat = "#";
    

      // chart.interpolationDuration = 50000;
    }, 100);
  }
  // Non Productive -- Gas Consumption chart Full View
  DrawChartGCNP() {
    setTimeout(() => {

      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("ECgraph1", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;

      // Add data
      chart.data = this.GCfdata;

      chart.colors.list = [
        am4core.color("#00ff00"),
        am4core.color("#03c03c"),
        am4core.color("#2e8b57"),
        am4core.color("#3fff00"),
        am4core.color("#059033"),
        am4core.color("#009900"),
        am4core.color("#008000"),
        am4core.color("#195905"),
        am4core.color("#8fd400"),
        am4core.color("#76ff7a"),
        am4core.color("#50c878"),
        am4core.color("#00ff7f"),
      ];

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.marginRight = 50;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.min = 0;
      valueAxis.title.text = "Gas Consumption(BTU)";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 12;
      valueAxis.cursorTooltipEnabled = false;
      // Create series
      function createSeries(field, name) {
        // Set up series
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.name = name;
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "obs_time_real";
        series.sequencedInterpolation = true;
        series.stacked = true;
        series.strokeWidth = 1;
       

        // Configure columns
        series.columns.template.width = am4core.percent(70);
        series.tooltipText = " [font-size: 12px]Gas Consumption :{valueY.formatNumber('#.')}";

       
        return series;
      }

      for (let i = 0; i < this.data.graphGCNames.length; i++) {
        let GCMixIdName = this.data.graphGCNames[i];
        createSeries(GCMixIdName, GCMixIdName);
      }

      
    }, 150);
  }
  // Mix Tons Run chart Full View
  DrawMixID() {
    setTimeout(() => {
      am4core.useTheme(am4themes_animated);
      let chart = am4core.create("chartdiv2", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;

      // Add data
      var chartData = this.mixIdData;
      chart.data = chartData;

      chart.colors.list = [
        am4core.color("#a8d279"),
        am4core.color("#8bc550"),
        am4core.color("#6bbe45"),
        am4core.color("#40ac48"),
        am4core.color("#2c8943"),
        am4core.color("#1e6431"),
      ]
      

      // Create axes
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.numberFormatter.numberFormat = "#";
      categoryAxis.renderer.labels.template.fontSize = 12;
      categoryAxis.title.fontSize = 12;
      categoryAxis.title.fill = am4core.color("#FFF");
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;
      chart.cursor.lineY.disabled = true;
      chart.cursor.behavior = "none";

      chart.legend = new am4charts.Legend();
      chart.legend.useDefaultMarker = true;
      chart.legend.fontSize = 10;
      chart.legend.labels.template.fill = am4core.color('#fff');
      chart.legend.position = "bottom";
      chart.legend.contentAlign = "center";
      chart.legend.itemContainers.template.width = am4core.percent(20);
      chart.legend.markers.template.width = 16;
      chart.legend.markers.template.height = 16;


      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.disabled = false;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.marginRight = 45;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.min = 0;
      valueAxis.title.text = "Total Mix Tons";
      valueAxis.title.fill = am4core.color("#FFF");
      valueAxis.title.fontSize = 12;
      valueAxis.cursorTooltipEnabled = false;

      var title = chart.titles.create();
      title.fill = am4core.color("#FFF");
      var resetLabel = chart.plotContainer.createChild(am4core.Label);
      resetLabel.text = "[bold]<< Back[/]";
      resetLabel.fill = am4core.color("#ffffff");
      resetLabel.x = -30;
      resetLabel.y = -30;
      resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
      resetLabel.hide();
      resetLabel.events.on(
        "hit",
        function (ev) {
          resetLabel.hide();
          title.hide();
          this.IsDropdownTrue = true;
          chart.data = chartData;
        },
        this
      );

      interface DataContext {
        hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
        obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
        // Add other properties if necessary
      }
      function createSeries(field, name) {
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "obs_time_real";
        series.name = name;
        series.stacked = true;
        series.strokeWidth = 1;
        series.sequencedInterpolation = true;
        series.legendSettings.labelText = " [{stroke} {name}][/]";
        series.legendSettings.valueText =
          "[#fff font-size:12px font-weight:bold] {name}[/]";
        series.columns.template.width = am4core.percent(70);
        series.tooltipText = " [font-size: 12px]{name}\n{valueY.formatNumber('#.0')} Tons";
        // Customize other properties of the series as needed

        return series;
      }
      for (let i = 0; i < this.MixIdNames.length; i++) {
        let MixIdName = this.MixIdNames[i];
        let series = createSeries(MixIdName, MixIdName); // Create and capture the series variable
        series.columns.template.events.on("hit", (ev) => {
          const dataContext = ev.target.dataItem.dataContext as DataContext;
          if (Array.isArray(dataContext.hourly)) {
            chart.titles.getIndex(0).text =
              " Hourly MixID " + " " + "-" + " " + dataContext.obs_time_real;
            chart.data = dataContext.hourly;
            resetLabel.show();
            title.show();
            this.IsDropdownTrue = false;
          }
        });
      }
    }, 150);
  }
  // Production Efficiency chart Full View
drawProductionChart() {
  setTimeout(() => {
    // Create chart instance
    let chart = am4core.create("proddiv", am4charts.XYChart);
    chart.logo.disabled = true;
    chart.paddingRight = 15;
    chart.numberFormatter.numberFormat = "#";
    
    // Add data
    chart.data = this.ProdEff;

    // Create X axis
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "mix_id";
    categoryAxis.title.text = "Mix ID";
    categoryAxis.title.fill = am4core.color("#FFF");
    categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
    categoryAxis.renderer.minGridDistance = 50;
    categoryAxis.renderer.labels.template.fontSize = 12;
    categoryAxis.renderer.labels.template.rotation = 45; // or 30 for a softer tilt
categoryAxis.renderer.labels.template.horizontalCenter = "middle";
categoryAxis.renderer.labels.template.verticalCenter = "middle";
    // Add cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = categoryAxis;

    // Create Y axis
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = "Production Efficiency(%)";
    valueAxis.title.fill = am4core.color("#FFF");
    valueAxis.title.fontSize = 12;
    valueAxis.renderer.labels.template.fontSize = 12;
    valueAxis.renderer.labels.template.fill = am4core.color("#fff");
    valueAxis.cursorTooltipEnabled = false;
    
    // Create series
    let series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "production_efficiency";
    series.dataFields.categoryX = "mix_id";
    series.tooltipText = "[font-size: 12px]{categoryX}: {valueY.formatNumber('#.')}%";
    series.strokeWidth = 3;
    series.name = "Production Efficiency";
    series.columns.template.width = am4core.percent(30);
    
    // Define color based on efficiency value
    series.columns.template.adapter.add("fill", function(fill, target) {
      if (!target.dataItem) return fill;
      
      const value = target.dataItem.values.valueY.value;
      
      if (value <= 30) {
        return am4core.color("#8B0000"); // Dark red
      } else if (value <= 60) {
        return am4core.color("#CD5C5C"); // Indian red
      } else if (value <= 90) {
        return am4core.color("#FFA07A"); // Light salmon
      } else if (value <= 110) {
        return am4core.color("#FFFF00"); // Yellow
      } else if (value <= 140) {
        return am4core.color("#ADFF2F"); // Green yellow
      } else if (value <= 170) {
        return am4core.color("#32CD32"); // Lime green
      } else {
        return am4core.color("#006400"); // Dark green
      }
    });
    
    // Set stroke color to match fill color
    series.columns.template.stroke = am4core.color("#000");
    
    // Tooltip configuration
    chart.tooltip.label.maxWidth = 150;
    chart.tooltip.label.wrap = true;
    
    // Add labels on top of the columns
    let labelBullet = series.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.text = "{valueY}%";
    labelBullet.label.fill = am4core.color("#fff");
    labelBullet.label.fontSize = 12;
    labelBullet.label.fontWeight = "bold";
    labelBullet.label.verticalCenter = "bottom";
    labelBullet.label.dy = -5;

    
    // Disable responsiveness if needed
    chart.responsive.enabled = false;
  }, 150);
}
 
  // Quality Efficiency chart Full View
  drawQualityeffncyChart() {
    setTimeout(() => {
      let ref = this;
      am4core.useTheme(am4themes_animated);
      // Themes end

      // Create chart instance
      let chart = am4core.create("qualdrum1", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;

      // Add data
      chart.data = this.QualEff;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.title.text = "Date";
      categoryAxis.title.fill = am4core.color("#FFF");
    
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.labels.template.fontSize = 12;
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;

     

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.title.text = "Quality Efficiency (%)";
      valueAxis.title.fill = am4core.color("#FFF");
      //  valueAxis.title.fontWeight = 'bold';
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
     
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "quality_eff";
      series.dataFields.categoryX = "obs_time_real";
      // series.tooltipText = "Quality Efficiency" + `:{${"quality_eff"}}`;
      series.tooltipText = " [font-size: 12px] {name}:{valueY.formatNumber('#.')}(%)";
      series.strokeWidth = 3;
      // series.tensionX = 0.9;
      series.stroke = am4core.color("#55FF5C");
     
      series.name = " Quality Efficiency ";
      series.legendSettings.labelText = "[{stroke}]{name}[/]";
      series.columns.template.width = am4core.percent(30);
      series.columns.template.fill = am4core.color("#55FF5C");
      series.columns.template.stroke = am4core.color("#0eab73");
      series.columns.template.adapter.add("stroke", function (stroke, target) {
        if (
          target.dataItem &&
          target.dataItem.values.valueY.value >= 0 &&
          target.dataItem.values.valueY.value <= 90
        ) {
          return am4core.color("#e5b027");
        } else if (
          target.dataItem &&
          target.dataItem.values.valueY.value > 90 &&
          target.dataItem &&
          target.dataItem.values.valueY.value <= 97
        ) {
          return am4core.color("#FFA500");
        } else {
          return am4core.color("#0eab73");
        }
      });
      series.columns.template.adapter.add("fill", function (fill, target) {
        if (
          target.dataItem &&
          target.dataItem.values.valueY.value >= 0 &&
          target.dataItem.values.valueY.value <= 90
        ) {
          return am4core.color("#e5b027");
        } else if (
          target.dataItem &&
          target.dataItem.values.valueY.value > 90 &&
          target.dataItem &&
          target.dataItem.values.valueY.value <= 97
        ) {
          return am4core.color("#FFA500");
        } else {
          return am4core.color("#0eab73");
        }
      });
      categoryAxis.title.fontSize = 12;

      

      chart.tooltip.label.maxWidth = 150;
      chart.tooltip.label.wrap = true;
      //  chart.responsive.enabled = false;

      
    }, 150);
  }
  // Energy Efficiency chart Full View (opeartion And Non Productive)
  drawEnergyeffncyChart() {
    setTimeout(() => {
      let ref = this;
      am4core.useTheme(am4themes_animated);
      // Themes end

      // Create chart instance
      let chart = am4core.create("ACReal", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      // chart.numberFormatter.numberFormat = "#";

      // Add data
      chart.data = this.EnergyEff;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.title.text = "Date";
      categoryAxis.title.fill = am4core.color("#FFF");

      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.labels.template.fontSize = 12;
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.title.text = "Energy Efficiency  (%) ";
      valueAxis.title.fill = am4core.color("#FFF");
      //  valueAxis.title.fontWeight = 'bold';
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
      // valueAxis.numberFormatter.numberFormat = "#.0";
      // Create series

      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "energy_eff";
      series.dataFields.categoryX = "obs_time_real";
      // series.tooltipText = " Energy Efficiency" + `:{${"energy_eff"}}`;
      series.tooltipText = " [font-size: 12px] {name}:{valueY.formatNumber('#.')}(%)";
      series.strokeWidth = 3;
      
      series.tooltip.label.propertyFields.fill = "#fff";
      // series.legendSettings.valueText = "Performance Efficiency [bold][/]";
      series.name = "Energy Efficiency ";
      series.legendSettings.labelText = "[{stroke}]{name}[/]";
      // series.label.text ="{valueY}";
      series.columns.template.width = am4core.percent(30);
      series.columns.template.fill = am4core.color("#55FF5C");
      series.columns.template.stroke = am4core.color("#0eab73");
      series.columns.template.adapter.add("stroke", function (stroke, target) {
        if (
          target.dataItem &&
          target.dataItem.values.valueY.value >= 0 &&
          target.dataItem.values.valueY.value <= 90
        ) {
          return am4core.color("#e5b027");
        } else if (
          target.dataItem &&
          target.dataItem.values.valueY.value > 90 &&
          target.dataItem &&
          target.dataItem.values.valueY.value <= 97
        ) {
          return am4core.color("#FFA500");
        } else {
          return am4core.color("#0eab73");
        }
      });
      series.columns.template.adapter.add("fill", function (fill, target) {
        if (
          target.dataItem &&
          target.dataItem.values.valueY.value >= 0 &&
          target.dataItem.values.valueY.value <= 90
        ) {
          return am4core.color("#e5b027");
        } else if (
          target.dataItem &&
          target.dataItem.values.valueY.value > 90 &&
          target.dataItem &&
          target.dataItem.values.valueY.value <= 97
        ) {
          return am4core.color("#FFA500");
        } else {
          return am4core.color("#0eab73");
        }
      });
      categoryAxis.title.fontSize = 12;

   

      chart.tooltip.label.maxWidth = 150;
      chart.tooltip.label.wrap = true;
      chart.responsive.enabled = false;

      
    }, 150);
  }
  // Carbon Index   chart Full View (opeartion And Non Productive)
  drawCarbonIndexchart() {
    setTimeout(() => {
      let ref = this;
      am4core.useTheme(am4themes_animated);
      // Themes end

      // Create chart instance
      let chart = am4core.create("Carbonindex", am4charts.XYChart);
      chart.logo.disabled = true;
      chart.paddingRight = 15;
      chart.numberFormatter.numberFormat = "#";
      

      // Add data
      chart.data =  this.CarbonEff ;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "obs_time_real";
      categoryAxis.title.text = "Date";
      categoryAxis.title.fill = am4core.color("#FFF");
     
      categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.labels.template.fontSize = 12;
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = categoryAxis;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.max = 100;
      valueAxis.title.text = "Carbon Efficiency  (%) ";
      valueAxis.title.fill = am4core.color("#FFF");
      //  valueAxis.title.fontWeight = 'bold';
      valueAxis.title.fontSize = 12;
      valueAxis.renderer.labels.template.fontSize = 12;
      valueAxis.renderer.labels.template.fill = am4core.color("#fff");
      valueAxis.cursorTooltipEnabled = false;
      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "carbon_eff";
      series.dataFields.categoryX = "obs_time_real";
      // series.tooltipText = "Carbon Index" + `:{${"carbon_index"}}`;
      series.tooltipText = "  [font-size: 12px]{name}:{valueY.formatNumber('#.')}(%)";
      series.strokeWidth = 3;
      

      series.name = " Carbon Efficiency ";
      series.legendSettings.labelText = "[{stroke}]{name}[/]";
      series.columns.template.width = am4core.percent(30);
      series.columns.template.fill = am4core.color("#55FF5C");
      series.columns.template.stroke = am4core.color("#0eab73");
      series.columns.template.adapter.add("stroke", function (stroke, target) {
        if (
          target.dataItem &&
          target.dataItem.values.valueY.value >= 0 &&
          target.dataItem.values.valueY.value <= 90
        ) {
          return am4core.color("#e5b027");
        } else if (
          target.dataItem &&
          target.dataItem.values.valueY.value > 90 &&
          target.dataItem &&
          target.dataItem.values.valueY.value <= 97
        ) {
          return am4core.color("#FFA500");
        } else {
          return am4core.color("#0eab73");
        }
      });
      series.columns.template.adapter.add("fill", function (fill, target) {
        if (
          target.dataItem &&
          target.dataItem.values.valueY.value >= 0 &&
          target.dataItem.values.valueY.value <= 90
        ) {
          return am4core.color("#e5b027");
        } else if (
          target.dataItem &&
          target.dataItem.values.valueY.value > 90 &&
          target.dataItem &&
          target.dataItem.values.valueY.value <= 97
        ) {
          return am4core.color("#FFA500");
        } else {
          return am4core.color("#0eab73");
        }
      });
      categoryAxis.title.fontSize = 12;

      

      chart.tooltip.label.maxWidth = 150;
      chart.tooltip.label.wrap = true;
      
    }, 150);
  }

    // Gas Consumption - Throughput Productive Graph Funtion 
    DrawChartTP() {
      setTimeout(() => {
        let ref = this;
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartGTP1", am4charts.XYChart);
        chart.logo.disabled = true;
        chart.paddingRight = 15;
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";
  
        // Add data
        var chartData = this.TPdata;
        chart.data = chartData;
  
        chart.colors.list = [
          am4core.color("#00ff00"),
          am4core.color("#03c03c"),
          am4core.color("#2e8b57"),
          am4core.color("#3fff00"),
          am4core.color("#059033"),
          am4core.color("#009900"),
          am4core.color("#008000"),
          am4core.color("#195905"),
          am4core.color("#8fd400"),
          am4core.color("#76ff7a"),
          am4core.color("#50c878"),
          am4core.color("#00ff7f"),
        ];
  
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "obs_time_real";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 50;
        categoryAxis.numberFormatter.numberFormat = "#";
        categoryAxis.renderer.labels.template.fontSize = 12;
        categoryAxis.title.fontSize = 12;
        categoryAxis.title.fill = am4core.color("#FFF");
        categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
  
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = categoryAxis;
        chart.cursor.lineY.disabled = true;
        chart.cursor.behavior = "none";

        // Create scientific notation formatter
        const scientificFormatter = new am4core.NumberFormatter();
        scientificFormatter.numberFormat = "#.#a";
        scientificFormatter.bigNumberPrefixes = [
          { "number": 1e3, "suffix": "K" },
          { "number": 1e6, "suffix": "M" },
          { "number": 1e9, "suffix": "B" },
          { "number": 1e12, "suffix": "T" }
        ];
  
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inside = true;
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.marginRight = 50;
        valueAxis.renderer.labels.template.fill = am4core.color("#fff");
        valueAxis.min = 0;
        valueAxis.title.text = "Gas Consumption(BTU)";
        valueAxis.title.fill = am4core.color("#FFF");
        valueAxis.title.fontSize = 12;
        valueAxis.cursorTooltipEnabled = false;
        valueAxis.numberFormatter = scientificFormatter;
  
        let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis2.maxPrecision = 0;
        valueAxis2.title.text = "Throughput (TPH)";
        valueAxis2.title.fontSize = "12px";
        valueAxis2.title.fill = am4core.color("#FFF");
        valueAxis2.cursorTooltipEnabled = false;
        valueAxis2.renderer.opposite = true;
        valueAxis2.min = 0;
        valueAxis2.syncWithAxis = valueAxis;
        valueAxis2.renderer.labels.template.fontSize = 12;
        valueAxis2.renderer.labels.template.fill = am4core.color("#fff");
  
        var title = chart.titles.create();
        title.fill = am4core.color("#FFF");
        var resetLabel = chart.plotContainer.createChild(am4core.Label);
        resetLabel.text = "[bold]<< Back[/]";
        resetLabel.fill = am4core.color("#ffffff");
        resetLabel.x = -30;
        resetLabel.y = -30;
        resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        resetLabel.hide();
        resetLabel.events.on(
          "hit",
          function (ev) {
            resetLabel.hide();
            title.hide();
  
            chart.data = chartData;
          },
          this
        );
  
        interface DataContext {
          hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
          obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
          // Add other properties if necessary
        }
  
        // Create series
        function createSeries(field, name) {
          // Set up series
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "obs_time_real";
          series.sequencedInterpolation = true;
          series.stacked = true;
          series.strokeWidth = 1;
          series.legendSettings.labelText = " [{stroke} {name}][/]";
          series.legendSettings.valueText = "[#fff font-size:12px ] {name}[/]";
  
          // Configure columns
          series.columns.template.width = am4core.percent(40);
          // series.tooltipText = "{name}\n{valueY.formatNumber('#.')}";
          series.tooltipText =
            " [font-size: 12px]{name}\n{valueY.formatNumber('#.')}" + " " + "(BTU)";
          return series;
        }
        for (let i = 0; i < this.TPIdNames.length; i++) {
          let TPIdName = this.TPIdNames[i];
          let series = createSeries(TPIdName, TPIdName);
          series.columns.template.events.on("hit", (ev) => {
            const dataContext = ev.target.dataItem.dataContext as DataContext;
            if (Array.isArray(dataContext.hourly)) {
              chart.titles.getIndex(0).text =
                " Hourly MixID " + " " + "-" + " " + dataContext.obs_time_real;
              chart.data = dataContext.hourly;
              resetLabel.show();
              title.show();
            }
          });
        }
  
        function createSeries1(field, name) {
          // Set up series
          let series1 = chart.series.push(new am4charts.LineSeries());
          series1.name = name;
          series1.dataFields.valueY = field;
          series1.dataFields.categoryX = "obs_time_real";
          series1.yAxis = valueAxis2;
          series1.stroke = am4core.color("#D6E865");
          series1.fill = am4core.color("#D6E865");
  
          series1.tensionX = 0.9;
          series1.propertyFields.strokeDasharray = "lineDash";
          series1.strokeWidth = 3;
          series1.legendSettings.labelText = " [{stroke} {name}][/]";
          series1.legendSettings.valueText =
            "[#fff font-size:12px ] Throughput[/]";
  
          // Configure columns
          series1.tooltipText = " [font-size: 12px]Throughput:{valueY.formatNumber('#.00')}(TPH)";
          let bullet1 = series1.bullets.push(new am4charts.Bullet());
          bullet1.fill = am4core.color("#D6E865"); // tooltips grab fill from parent by default
          let circle1 = bullet1.createChild(am4core.Circle);
          circle1.radius = 4;
          circle1.strokeWidth = 3;
          return series1;
        }
        for (let i = 0; i < this.TPName.length; i++) {
          let TPtonIdName = this.TPName[i];
          createSeries1(TPtonIdName, TPtonIdName);
        }
      }, 150);
    }


    DrawChartGAD() {
      setTimeout(() => {
        let ref = this;
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartGad1", am4charts.XYChart);
        chart.logo.disabled = true;
        chart.paddingRight = 15;
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";
  
        // Add data
        var chartData = this.mergedData;
        chart.data = chartData;
  
        chart.colors.list = [
          am4core.color("#00ff00"),
          am4core.color("#03c03c"),
          am4core.color("#2e8b57"),
          am4core.color("#3fff00"),
          am4core.color("#059033"),
          am4core.color("#009900"),
          am4core.color("#008000"),
          am4core.color("#195905"),
          am4core.color("#8fd400"),
          am4core.color("#76ff7a"),
          am4core.color("#50c878"),
          am4core.color("#00ff7f"),
        ];
  
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "obs_time_real";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 50;
        categoryAxis.numberFormatter.numberFormat = "#";
        categoryAxis.renderer.labels.template.fontSize = 12;
        categoryAxis.title.fontSize = 12;
        categoryAxis.title.fill = am4core.color("#FFF");
        categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
  
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = categoryAxis;
        chart.cursor.lineY.disabled = true;
        chart.cursor.behavior = "none";

                    // Create scientific notation formatter
                    const scientificFormatter = new am4core.NumberFormatter();
                    scientificFormatter.numberFormat = "#.#a";
                    scientificFormatter.bigNumberPrefixes = [
                      { "number": 1e3, "suffix": "K" },
                      { "number": 1e6, "suffix": "M" },
                      { "number": 1e9, "suffix": "B" },
                      { "number": 1e12, "suffix": "T" }
                    ];
  
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inside = true;
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.marginRight = 50;
        valueAxis.renderer.labels.template.fill = am4core.color("#fff");
        valueAxis.min = 0;
        valueAxis.title.text = "Gas Consumption(BTU)";
        valueAxis.title.fill = am4core.color("#FFF");
        valueAxis.title.fontSize = 12;
        valueAxis.cursorTooltipEnabled = false;
        valueAxis.numberFormatter = scientificFormatter;
  
        let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis2.maxPrecision = 0;
        valueAxis2.title.text = "Drumshell Temperature (°F)";
        valueAxis2.title.fontSize = "12px";
        valueAxis2.title.fill = am4core.color("#FFF");
        valueAxis2.cursorTooltipEnabled = false;
        valueAxis2.renderer.opposite = true;
        valueAxis2.min = 0;
        valueAxis2.syncWithAxis = valueAxis;
        valueAxis2.renderer.labels.template.fontSize = 12;
        valueAxis2.renderer.labels.template.fill = am4core.color("#fff");
  
        
      
        var title = chart.titles.create();
        title.fill = am4core.color("#FFF");
        var resetLabel = chart.plotContainer.createChild(am4core.Label);
        resetLabel.text = "[bold]<< Back[/]";
        resetLabel.fill = am4core.color("#ffffff");
        resetLabel.x = -30;
        resetLabel.y = -30;
        resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        resetLabel.hide();
        resetLabel.events.on(
          "hit",
          function (ev) {
            resetLabel.hide();
            title.hide();
  
            chart.data = chartData;
          },
          this
        );
  
        interface DataContext {
          hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
          obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
          // Add other properties if necessary
        }
  
        // Create series
        function createSeries(field, name) {
          // Set up series
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "obs_time_real";
          series.sequencedInterpolation = true;
          series.stacked = true;
          series.strokeWidth = 1;
          series.legendSettings.labelText = " [{stroke} {name}][/]";
          series.legendSettings.valueText = "[#fff font-size:12px ] {name}[/]";
  
          // Configure columns
          series.columns.template.width = am4core.percent(40);
          // series.tooltipText = "{name}\n{valueY.formatNumber('#.')}";
          series.tooltipText =
            " [font-size: 12px]{name}\n{valueY.formatNumber('#.')}" + " " + "(BTU)";
          return series;
        }
        for (let i = 0; i < this.GADIdnames.length; i++) {
          let GADIdName = this.GADIdnames[i];
          let series = createSeries(GADIdName, GADIdName);
          series.columns.template.events.on("hit", (ev) => {
            const dataContext = ev.target.dataItem.dataContext as DataContext;
            if (Array.isArray(dataContext.hourly)) {
              chart.titles.getIndex(0).text =
                " Hourly MixID " + " " + "-" + " " + dataContext.obs_time_real;
              chart.data = dataContext.hourly;
              resetLabel.show();
              title.show();
            }
          });
        }
  
        function createSeries1(field, name) {
          // Set up series
          let series1 = chart.series.push(new am4charts.LineSeries());
          series1.name = name;
          series1.dataFields.valueY = field;
          series1.dataFields.categoryX = "obs_time_real";
          series1.yAxis = valueAxis2;
          series1.stroke = am4core.color("#D6E865");
          series1.fill = am4core.color("#D6E865");
  
          series1.tensionX = 0.9;
          series1.propertyFields.strokeDasharray = "lineDash";
          series1.strokeWidth = 3;
          series1.legendSettings.labelText = " [{stroke} {name}][/]";
          series1.legendSettings.valueText =
            "[#fff font-size:12px ] Drumshell Temperature (°F)[/]";
  
          // Configure columns
          series1.tooltipText = " [font-size: 12px]Drumshell:{valueY.formatNumber('#.00')}(°F)";
          let bullet1 = series1.bullets.push(new am4charts.Bullet());
          bullet1.fill = am4core.color("#D6E865"); // tooltips grab fill from parent by default
          let circle1 = bullet1.createChild(am4core.Circle);
          circle1.radius = 4;
          circle1.strokeWidth = 3;
          return series1;
        }
        for (let i = 0; i < this.DrumName.length; i++) {
          let DrumIdName = this.DrumName[i];
          createSeries1(DrumIdName, DrumIdName);
        }
  
        
      }, 150);
    }

    DrawChartNPGAD() {
      setTimeout(() => {
        let ref = this;
        am4core.useTheme(am4themes_animated);
        let chart = am4core.create("chartNPPGAD", am4charts.XYChart);
        chart.logo.disabled = true;
        chart.paddingRight = 15;
  
        // Add data
        var chartData = this.mergedData;
        chart.data = chartData;
  
        chart.colors.list = [
          am4core.color("#00ff00"),
          am4core.color("#03c03c"),
          am4core.color("#2e8b57"),
          am4core.color("#3fff00"),
          am4core.color("#059033"),
          am4core.color("#009900"),
          am4core.color("#008000"),
          am4core.color("#195905"),
          am4core.color("#8fd400"),
          am4core.color("#76ff7a"),
          am4core.color("#50c878"),
          am4core.color("#00ff7f"),
        ];
  
        // Create axes
        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "obs_time_real";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 50;
        categoryAxis.numberFormatter.numberFormat = "#";
        categoryAxis.renderer.labels.template.fontSize = 12;
        categoryAxis.title.fontSize = 12;
        categoryAxis.title.fill = am4core.color("#FFF");
        categoryAxis.renderer.labels.template.fill = am4core.color("#fff");
  
        chart.cursor = new am4charts.XYCursor();
        chart.cursor.xAxis = categoryAxis;
        chart.cursor.lineY.disabled = true;
        chart.cursor.behavior = "none";
  
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inside = true;
        valueAxis.renderer.labels.template.disabled = false;
        valueAxis.renderer.labels.template.fontSize = 12;
        valueAxis.marginRight = 50;
        valueAxis.renderer.labels.template.fill = am4core.color("#fff");
        valueAxis.min = 0;
        valueAxis.title.text = "Gas Consp (BTU)";
        valueAxis.title.fill = am4core.color("#FFF");
        valueAxis.title.fontSize = 12;
        valueAxis.cursorTooltipEnabled = false;
  
        let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis2.maxPrecision = 0;
        valueAxis2.title.text = "Drumshell Temp (°F)";
        valueAxis2.title.fontSize = "12px";
        valueAxis2.title.fill = am4core.color("#FFF");
        valueAxis2.cursorTooltipEnabled = false;
        valueAxis2.renderer.opposite = true;
        valueAxis2.min = 0;
        valueAxis2.syncWithAxis = valueAxis;
        valueAxis2.renderer.labels.template.fontSize = 12;
        valueAxis2.renderer.labels.template.fill = am4core.color("#fff");
  
        let valueAxis3 = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis3.maxPrecision = 0;
        valueAxis3.title.text = "Ambient Temp (°F)";
        valueAxis3.title.fontSize = "12px";
        valueAxis3.title.fill = am4core.color("#FFF");
        valueAxis3.cursorTooltipEnabled = false;
        valueAxis3.renderer.opposite = true;
        valueAxis3.min = 0;
        valueAxis3.syncWithAxis = valueAxis;
        valueAxis3.renderer.labels.template.fontSize = 12;
        valueAxis3.renderer.labels.template.fill = am4core.color("#fff");
  
        var title = chart.titles.create();
        title.fill = am4core.color("#FFF");
        var resetLabel = chart.plotContainer.createChild(am4core.Label);
        resetLabel.text = "[bold]<< Back[/]";
        resetLabel.fill = am4core.color("#ffffff");
        resetLabel.x = -30;
        resetLabel.y = -30;
        resetLabel.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        resetLabel.hide();
        resetLabel.events.on(
          "hit",
          function (ev) {
            resetLabel.hide();
            title.hide();
  
            chart.data = chartData;
          },
          this
        );
  
        interface DataContext {
          hourly: any[]; // Replace 'any' with the actual type of the 'hourly' property
          obs_time_real: string; // Replace 'string' with the actual type of 'obs_time_real' property if needed
          // Add other properties if necessary
        }
  
        // Create series
        function createSeries(field, name) {
          // Set up series
          let series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "obs_time_real";
          series.sequencedInterpolation = true;
          series.stacked = true;
          series.strokeWidth = 1;
          series.legendSettings.labelText = " [{stroke} NP_GasConsp][/]";
          series.legendSettings.valueText = "[#fff font-size:12px ] NP_GasConsp[/]";
  
          // Configure columns
          series.columns.template.width = am4core.percent(40);
          // series.tooltipText = "{name}\n{valueY.formatNumber('#.')}";
          series.tooltipText =
            "[font-size: 12px]NP_GasConsp:{valueY.formatNumber('#.')}" + " " + "(BTU)";
          return series;
        }
        for (let i = 0; i < this.GADIdnames.length; i++) {
          let GADIdName = this.GADIdnames[i];
          let series = createSeries(GADIdName, GADIdName);
          series.columns.template.events.on("hit", (ev) => {
            const dataContext = ev.target.dataItem.dataContext as DataContext;
            if (Array.isArray(dataContext.hourly)) {
              chart.titles.getIndex(0).text =
                " Hourly MixID " + " " + "-" + " " + dataContext.obs_time_real;
              chart.data = dataContext.hourly;
              resetLabel.show();
              title.show();
            }
          });
        }
  
        function createSeries1(field, name) {
          // Set up series
          let series1 = chart.series.push(new am4charts.LineSeries());
          series1.name = name;
          series1.dataFields.valueY = field;
          series1.dataFields.categoryX = "obs_time_real";
          series1.yAxis = valueAxis2;
          series1.stroke = am4core.color("#D6E865");
          series1.fill = am4core.color("#D6E865");
  
          series1.tensionX = 0.9;
          series1.propertyFields.strokeDasharray = "lineDash";
          series1.strokeWidth = 3;
          series1.legendSettings.labelText = " [{stroke} {name}][/]";
          series1.legendSettings.valueText =
            "[#fff font-size:12px ] Drumshell Temp[/]";
  
          // Configure columns
          series1.tooltipText = "[font-size: 12px]Drumshell:{valueY.formatNumber('#.00')}(°F)";
          let bullet1 = series1.bullets.push(new am4charts.Bullet());
          bullet1.fill = am4core.color("#D6E865"); // tooltips grab fill from parent by default
          let circle1 = bullet1.createChild(am4core.Circle);
          circle1.radius = 4;
          circle1.strokeWidth = 3;
          return series1;
        }
        for (let i = 0; i < this.DrumName.length; i++) {
          let DrumIdName = this.DrumName[i];
          createSeries1(DrumIdName, DrumIdName);
        }
  
        function createSeries2(field, name) {
          // Set up series
          let series2 = chart.series.push(new am4charts.LineSeries());
          series2.name = name;
          series2.dataFields.valueY = field;
          series2.dataFields.categoryX = "obs_time_real";
          series2.yAxis = valueAxis3;
          series2.stroke = am4core.color("#32CD30");
          series2.fill = am4core.color("#32CD30");
  
          series2.tensionX = 0.9;
          series2.propertyFields.strokeDasharray = "lineDash";
          series2.strokeWidth = 3;
          series2.legendSettings.labelText = " [{stroke} {name}][/]";
          series2.legendSettings.valueText =
            "[#fff font-size:12px ] Ambient Temp[/]";
  
          // Configure columns
          series2.tooltipText = "[font-size: 12px]Ambient :{valueY.formatNumber('#.00')}(°F)";
          let bullet2 = series2.bullets.push(new am4charts.Bullet());
          bullet2.fill = am4core.color("#32CD30"); // tooltips grab fill from parent by default
          let circle2 = bullet2.createChild(am4core.Circle);
          circle2.radius = 4;
          circle2.strokeWidth = 3;
          return series2;
        }
        for (let i = 0; i < this.AmbName.length; i++) {
          let AmbIdName = this.AmbName[i];
          createSeries2(AmbIdName, AmbIdName);
        }
  
        
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";
      }, 150);
    }
 

}
